import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { decryptUrlDatapattern, encryptUrlDatapattern } from "../../../../components/commonClass/EncFunc";
import { ClearLocalStorage, GetLocalStorage } from "../../../../components/commonClass/Session";
import { AlphabetAllows, alphaNumeric, alphaNumericWithSpace, calculateAge, isValidEmail, onlyNumeric } from "../../../../components/commonClass/CommonValidation";
import { calculateDOB, getPriceSummaryDetails } from "../../../../components/commonClass/CommonFunctions";
import { loaderActions } from "../../../../_actions/loader.actions";
import { postUsersData, verifytoken } from "../../../../services/ApiCallingUserServices";
import FlightReviewComponant from "../partial/FlightReviewComponant";
import PriceSummary from "../../DetailScreen/partial/PriceSummary";

const FlightAddTravellerForm = (props: any) => {
  const { flightFareQouteData, flightFareRuleData, dropdownData, setPassengersData, setOtherData, isDomRtn, UpdatedBookFlightData } = props;
  sessionStorage?.setItem("isFlightPurchase", "false")

  const isinternationalData = sessionStorage.getItem('isinternational');
  const isInternational = isinternationalData ? JSON.parse(isinternationalData) : false;

  const gstinregex = new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9]{1}Z[0-9A-Z]{1}$/);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const titleList = [
    { value: 1, label: "MR", genType: 1 },
    { value: 2, label: "MRS", genType: 2 },
    { value: 3, label: "MS", genType: 2 },
    { value: 4, label: "MSTR", genType: 1 },
  ]

  const mealList = [
    { value: 1, label: "Vegetarian Jain Meal" },
    { value: 2, label: "Vegetarian Meal" },
    { value: 3, label: "Baby Meal" },
    { value: 4, label: "Non Vegetarian Meal" }
  ]

  const genderList = [
    { value: 1, label: "Male" },
    { value: 2, label: "Female" },
  ]

  const [searchParams, setSearchParams] = useSearchParams();
  const [formError, setFormError] = useState<any>({});
  const [insertCollection, setInsertCollection] = useState<any>(null);
  const [initialData, setInitialData] = useState([]);

  const [formValue, setFormValue] = useState<any>(null)
  const [intOtherData, setIntOtherData] = useState<any>([]);
  const minDOB = '1900-01-01';

  const handlePage = (name: any) => {
    const newSearchParams = new URLSearchParams(searchParams);
    // newSearchParams?.set('pagename', encryptUrlDatapattern(name));
    // setSearchParams(newSearchParams);
    navigate({ pathname: `/flight/` + name, search: newSearchParams.toString() }, { state: location?.state })
  }

  const allPassangersData = (objectColl: any, withObjColl: any) => {
    let coll: any[] = [];
    if (objectColl) {
      Object.keys(objectColl)?.map((obj) => {
        if (objectColl?.[obj]?.length > 0) {
          if (withObjColl) {
            coll = { ...coll, [obj]: [...objectColl?.[obj]] };
          }
          else {
            coll = [...coll, ...objectColl?.[obj]];
          }
        }
      });
    }
    return coll;
  }

  useEffect(() => {
    sessionStorage.setItem('isContinue', encryptUrlDatapattern(false))
  }, [])

  useEffect(() => {
    if (intOtherData !== formValue && formValue !== null) {
      setOtherData(formValue);
      sessionStorage.setItem('tvldata', JSON.stringify(formValue))
    }
  }, [intOtherData, formValue])

  useEffect(() => {
    if (initialData !== insertCollection && insertCollection !== null) {
      sessionStorage.setItem('datas', JSON.stringify(insertCollection))
      // setFormValue((form) => ({ ...form, PersonCollection: allPassangersData(insertCollection, false) }))
      setPassengersData(allPassangersData(insertCollection, false))
    }
  }, [insertCollection, initialData])

  const defaultForm = {
    TravelerName: '',
    TitleId: 0,
    Title: 0,
    // FullName: '',
    FirstName: '',
    LastName: '',
    DateOfBirth: null,
    Age: "",
    tempDOB: '',
    Gender: 0,
    AirportLocationId: 0,
    City: "",
    CityCode: "",
    CountryId: 0,
    CountryCode: '',
    CountryName: '',
    CellCountryCode: '',
    Nationality: '',
    ContactNo: '',
    Email: '',
    PassportNo: '',
    PassportExpiry: null,
    tempExpiryDate: '',
    PassportIssueDate: null,
    tempPassportIssueDate: '',
    PassportIssueCountryCode: '',
    AddressLine1: '',
    AddressLine2: '',
    FFNumber: '',
    FFAirlineCode: '',
    MealId: 0,
    // IsLeadPax: false,
    GSTNumber: "",
    GSTCompanyName: "",
    GSTCompanyContactNumber: "",
    GSTCompanyEmail: "",
    GSTCompanyAddress: "",
  }

  //#region create adult, child and infant collection from theirs count
  useEffect(() => {
    if (flightFareQouteData?.[isDomRtn] !== undefined) {
      const userData: any = GetLocalStorage();

      const OtherChargesFare = flightFareQouteData?.[isDomRtn]?.response?.results?.fare?.otherCharges;

      flightFareQouteData?.[isDomRtn]?.response?.results?.fareBreakdown?.map((obj: any) => {
        const BaseFare = obj?.baseFare / obj?.passengerCount;
        const Tax = obj?.tax / obj?.passengerCount;
        const PassengerType = obj?.passengerType;
        const YQTax = obj?.yqTax;
        const AdditionalTxnFeePub = obj?.additionalTxnFeePub;
        const AdditionalTxnFeeOfrd = obj?.additionalTxnFeeOfrd;
        const OtherCharges = OtherChargesFare;

        obj.fareCalculation = { BaseFare, Tax, PassengerType, YQTax, AdditionalTxnFeePub, AdditionalTxnFeeOfrd, OtherCharges }
        return obj;
      })

      //#region adult, child and infant collection for insert, depend on their counts
      if (flightFareQouteData?.[isDomRtn]?.response?.results?.fareBreakdown?.length > 0) {
        const collection = flightFareQouteData?.[isDomRtn]?.response?.results?.fareBreakdown?.reduce((acc: any, curr: any, index: number, arr: any) => {
          if (curr?.passengerType === 1) {
            for (let i = 1; i <= curr?.passengerCount; i++) {
              acc?.adultColl?.push({ ...defaultForm, id: i, IsLeadPax: i === 1 ? true : false, PaxType: curr?.passengerType, Fare: curr?.fareCalculation, })
            }
          }
          if (curr?.passengerType === 2) {
            for (let i = 1; i <= curr?.passengerCount; i++) {
              acc?.childColl?.push({ ...defaultForm, id: i, IsLeadPax: false, PaxType: curr?.passengerType, Fare: curr?.fareCalculation, })
            }
          }
          if (curr?.passengerType === 3) {
            for (let i = 1; i <= curr?.passengerCount; i++) {
              acc?.infantColl?.push({ ...defaultForm, id: i, IsLeadPax: false, PaxType: curr?.passengerType, Fare: curr?.fareCalculation, })
            }
          }
          return acc;
        }, { adultColl: [], childColl: [], infantColl: [] });
        //#endregion

        const coll: any = allPassangersData(collection, true);
        const tid = decryptUrlDatapattern(searchParams.get('tId'));
        const tparam = sessionStorage?.getItem('tparam') ? decryptUrlDatapattern(sessionStorage?.getItem('tparam')) : '';

        const datainsertData = sessionStorage?.getItem('datas');
        const datainsert = datainsertData ? JSON.parse(datainsertData) : null;
        setInitialData(coll);
        setInsertCollection((datainsert !== null && tid === tparam) ? datainsert : JSON.parse(JSON.stringify(coll)));

        const formDetails = {
          AirportLocationId: 0,
          City: "",
          CityCode: "",
          CountryId: 0,
          CountryCode: '',
          CountryName: '',
          CellCountryCode: '',
          Nationality: '',
          MobileNo: "",
          Email: "",
          IsGST: false,
          GSTNumber: "",
          GSTCompanyName: "",
          GSTCompanyContactNumber: "",
          GSTCompanyEmail: "",
          GSTCompanyAddress: "",
          UserId: userData?.userMasterID
        }
        const tvldatas = sessionStorage?.getItem('tvldata')
        const otherdatas = tvldatas ? JSON.parse(tvldatas) : null;
        setIntOtherData(formDetails);
        setFormValue(tid === tparam ? otherdatas : JSON.parse(JSON.stringify(formDetails)));

        const tIdData = searchParams.get('tId');
        if (tid !== tparam) {
          sessionStorage?.setItem('tparam', tIdData ? tIdData : "");
          sessionStorage.setItem('passengers', '')
          sessionStorage.setItem('others', '')
        }
      }
    }
  }, [flightFareQouteData?.[isDomRtn]])
  //#endregion

  //#region date format function (yyyy-mm-dd) for insert collection
  function formatDate(date: any) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return date === null ? null : [year, month, day].join('-');
  }
  //#endregion

  //#region lead radio button on change for collection
  const handleLeadRadio = (e: any, id: any) => {
    setFormError({});
    let adult = insertCollection?.adultColl?.map((obj: any) => {
      if (obj?.id === id) {
        obj.IsLeadPax = true;
      }
      else {
        obj.IsLeadPax = false;
      }
      return obj;
    });
    setInsertCollection((coll: any) => ({ ...coll, adultColl: [...adult] }));
  }
  //#endregion


  //#region set lead contact details
  useEffect(() => {
    const leadAdultData = insertCollection?.adultColl?.find((obj: any) => obj?.IsLeadPax === true)
    if (leadAdultData !== undefined) {
      // handleSelectChange()
      setFormValue((form: any) => ({
        ...form,
        Email: leadAdultData?.Email || '',
        MobileNo: leadAdultData?.ContactNo || '',
        AirportLocationId: leadAdultData?.AirportLocationId || 0,
        City: leadAdultData?.City || "",
        CityCode: leadAdultData?.CityCode || "",
        CountryId: leadAdultData?.CountryId || 0,
        CountryCode: leadAdultData?.CountryCode || '',
        CountryName: leadAdultData?.CountryName || '',
        CellCountryCode: leadAdultData?.CellCountryCode || '',
        Nationality: leadAdultData?.Nationality || '',
      }))
    }

  }, [insertCollection?.adultColl])
  //#endregion

  const handleSelectSuggestion = (coll: any, e: any, id: any) => {
    setFormError({});
    const travelerData = dropdownData?.travellerList?.find((obj: any) => obj?.UserMasterID === Number(e.target.value));

    if (coll === 'adult') {
      const adult = insertCollection?.adultColl?.map((obj: any) => {
        if (obj?.id === id) {
          const titleData = titleList?.find(find => find?.value === travelerData?.TravellerTitleId);
          obj.TitleId = titleData?.value || 0;
          obj.Title = titleData?.label || '';
          obj.Gender = Number(travelerData?.TravellerTitleId) > 0 ? titleData?.genType : 0;

          obj.DateOfBirth = travelerData?.DateOfBirth ? formatDate(travelerData?.DateOfBirth) + "T00:00:00" : null;
          obj.tempDOB = travelerData?.DateOfBirth ? formatDate(travelerData?.DateOfBirth) : "";
          obj.Age = travelerData?.DateOfBirth ? calculateAge(formatDate(travelerData?.DateOfBirth)) : "";

          // obj.FullName = travelerData?.FullName ? travelerData?.FullName : '';
          obj.FirstName = travelerData?.FirstName ? travelerData?.FirstName : '';
          obj.LastName = travelerData?.LastName ? travelerData?.LastName : '';
          obj.TravelerName = Number(e.target.value);

          const countryData = dropdownData?.countryList?.find((find: any) => find?.CountryId === travelerData?.CountryId);
          obj.CountryId = countryData?.CountryId || 0;
          obj.CountryCode = countryData?.CountryCode || '';
          obj.CountryName = countryData?.CountryName || '';
          obj.CellCountryCode = countryData?.ISDCode || '';
          obj.Nationality = countryData?.CountryCode || '';
          obj.AirportLocationId = 0
          obj.City = ""
          obj.CityCode = ""

          obj.Email = travelerData?.UserEmail || '';
          obj.ContactNo = travelerData?.ContactNo || '';
          obj.AddressLine1 = travelerData?.Address || '';

          const issueCountryData = dropdownData?.countryList?.find((find: any) => find?.CountryId === travelerData?.IssuedCountryId);
          obj.PassportIssueCountryCode = issueCountryData?.CountryCode || '';
          obj.PassportNo = travelerData?.PassportNumber ? travelerData?.PassportNumber : "";
          obj.PassportExpiry = travelerData?.ExpiryDate ? formatDate(travelerData?.ExpiryDate) + "T00:00:00" : null;
          obj.tempExpiryDate = travelerData?.ExpiryDate ? formatDate(travelerData?.ExpiryDate) : "";
          obj.PassportIssueDate = travelerData?.IssueDate ? formatDate(travelerData?.IssueDate) + "T00:00:00" : null;
          obj.tempPassportIssueDate = travelerData?.IssueDate ? formatDate(travelerData?.IssueDate) : "";

        }
        return obj;
      });
      setInsertCollection((coll: any) => ({ ...coll, adultColl: [...adult] }));

    }
    else if (coll === 'child') {
      const child = insertCollection?.childColl?.map((obj: any) => {
        if (obj?.id === id) {
          const titleData = titleList?.find(find => find?.value === travelerData?.TravellerTitleId);
          obj.TitleId = titleData?.value || 0;
          obj.Title = titleData?.label || '';
          obj.Gender = Number(travelerData?.TravellerTitleId) > 0 ? titleData?.genType : 0;

          obj.DateOfBirth = travelerData?.DateOfBirth ? formatDate(travelerData?.DateOfBirth) + "T00:00:00" : null;
          obj.tempDOB = travelerData?.DateOfBirth ? formatDate(travelerData?.DateOfBirth) : "";
          obj.Age = travelerData?.DateOfBirth ? calculateAge(formatDate(travelerData?.DateOfBirth)) : "";

          // obj.FullName = travelerData?.FullName ? travelerData?.FullName : '';
          obj.FirstName = travelerData?.FirstName ? travelerData?.FirstName : '';
          obj.LastName = travelerData?.LastName ? travelerData?.LastName : '';
          obj.TravelerName = Number(e.target.value);
          obj.AddressLine1 = travelerData?.Address || '';

          let issueCountryData = dropdownData?.countryList?.find((find: any) => find?.CountryId === travelerData?.IssuedCountryId);
          obj.PassportIssueCountryCode = issueCountryData?.CountryCode || '';
          obj.PassportNo = travelerData?.PassportNumber ? travelerData?.PassportNumber : "";
          obj.PassportExpiry = travelerData?.ExpiryDate ? formatDate(travelerData?.ExpiryDate) + "T00:00:00" : null;
          obj.tempExpiryDate = travelerData?.ExpiryDate ? formatDate(travelerData?.ExpiryDate) : "";
          obj.PassportIssueDate = travelerData?.IssueDate ? formatDate(travelerData?.IssueDate) + "T00:00:00" : null;
          obj.tempPassportIssueDate = travelerData?.IssueDate ? formatDate(travelerData?.IssueDate) : "";
        }
        return obj;
      });
      setInsertCollection((coll: any) => ({ ...coll, childColl: [...child] }));
    }
    else if (coll === 'infant') {
      const infant = insertCollection?.infantColl?.map((obj: any) => {
        if (obj?.id === id) {
          const titleData = titleList?.find(find => find?.value === travelerData?.TravellerTitleId);
          obj.TitleId = titleData?.value || 0;
          obj.Title = titleData?.label || '';
          obj.Gender = Number(travelerData?.TravellerTitleId) > 0 ? titleData?.genType : 0;

          obj.DateOfBirth = travelerData?.DateOfBirth ? formatDate(travelerData?.DateOfBirth) + "T00:00:00" : null;
          obj.tempDOB = travelerData?.DateOfBirth ? formatDate(travelerData?.DateOfBirth) : "";
          obj.Age = travelerData?.DateOfBirth ? calculateAge(formatDate(travelerData?.DateOfBirth)) : "";

          // obj.FullName = travelerData?.FullName ? travelerData?.FullName : '';
          obj.FirstName = travelerData?.FirstName ? travelerData?.FirstName : '';
          obj.LastName = travelerData?.LastName ? travelerData?.LastName : '';
          obj.TravelerName = Number(e.target.value);
          obj.AddressLine1 = travelerData?.Address || '';

          let issueCountryData = dropdownData?.countryList?.find((find: any) => find?.CountryId === travelerData?.IssuedCountryId);
          obj.PassportIssueCountryCode = issueCountryData?.CountryCode || '';
          obj.PassportNo = travelerData?.PassportNumber ? travelerData?.PassportNumber : "";
          obj.PassportExpiry = travelerData?.ExpiryDate ? formatDate(travelerData?.ExpiryDate) + "T00:00:00" : null;
          obj.tempExpiryDate = travelerData?.ExpiryDate ? formatDate(travelerData?.ExpiryDate) : "";
          obj.PassportIssueDate = travelerData?.IssueDate ? formatDate(travelerData?.IssueDate) + "T00:00:00" : null;
          obj.tempPassportIssueDate = travelerData?.IssueDate ? formatDate(travelerData?.IssueDate) : "";
        }
        return obj;
      });
      setInsertCollection((coll: any) => ({ ...coll, infantColl: [...infant] }));
    }

  }

  //#region select title on chnage for collection
  const handleSelect = (coll: any, name: any, e: any, id: any) => {
    setFormError({});
    if (coll === 'adult') {
      const adult = insertCollection?.adultColl?.map((obj: any) => {
        if (obj?.id === id) {
          if (name === 'CountryId') {
            const countryData = dropdownData?.countryList?.find((find: any) => find?.CountryId === Number(e.target.value));

            obj.CountryId = countryData?.CountryId || 0
            obj.CountryCode = countryData?.CountryCode || ""
            obj.CountryName = countryData?.CountryName || ""
            obj.CellCountryCode = countryData?.ISDCode || ""
            obj.Nationality = countryData?.CountryCode || ""
            obj.AirportLocationId = 0
            obj.City = ""
            obj.CityCode = ""
          }
          else if (name === 'TitleId') {
            const titleData = titleList?.find(find => find?.value === Number(e.target.value));

            obj.TitleId = titleData?.value || 0
            obj.Title = titleData?.label || ""
            obj.Gender = titleData?.genType
          }
          else if (name === "PassportIssueCountryCode") {
            obj[name] = e.target.value;
          }
          else if (name === "AirportLocationId") {
            const cityData = dropdownData?.cityList?.find((find: any) => find?.AirportLocationId === Number(e.target.value));
            obj.AirportLocationId = Number(e.target.value);
            obj.City = cityData?.City;
            obj.CityCode = cityData?.CityCode;
          }
          else {
            obj[name] = Number(e.target.value);
          }
        }
        return obj;
      });
      setInsertCollection((coll: any) => ({ ...coll, adultColl: [...adult] }));
    }
    else if (coll === 'child') {
      const child = insertCollection?.childColl?.map((obj: any) => {
        if (obj?.id === id) {
          if (name === 'CountryId') {
            const countryData = dropdownData?.countryList?.find((find: any) => find?.CountryId === Number(e.target.value));

            obj.CountryId = countryData?.CountryId
            obj.CountryCode = countryData?.CountryCode
            obj.CountryName = countryData?.CountryName
            obj.CellCountryCode = countryData?.ISDCode
            obj.Nationality = countryData?.CountryCode
          }
          else if (name === 'TitleId') {
            const titleData = titleList?.find(find => find?.value === Number(e.target.value));

            obj.TitleId = titleData?.value || 0
            obj.Title = titleData?.label || ""
            obj.Gender = titleData?.genType
          }
          else if (name === "PassportIssueCountryCode") {
            obj[name] = e.target.value;
          }
          else {
            obj[name] = Number(e.target.value);
          }
        }
        return obj;
      });
      setInsertCollection((coll: any) => ({ ...coll, childColl: [...child] }));
    }
    else if (coll === 'infant') {
      const infant = insertCollection?.infantColl?.map((obj: any) => {
        if (obj?.id === id) {
          if (name === 'CountryId') {
            const countryData = dropdownData?.countryList?.find((find: any) => find?.CountryId === Number(e.target.value));

            obj.CountryId = countryData?.CountryId
            obj.CountryCode = countryData?.CountryCode
            obj.CountryName = countryData?.CountryName
            obj.CellCountryCode = countryData?.ISDCode
            obj.Nationality = countryData?.CountryCode
          }
          else if (name === 'TitleId') {
            const titleData = titleList?.find(find => find?.value === Number(e.target.value));

            obj.TitleId = titleData?.value || 0
            obj.Title = titleData?.label || ""
            obj.Gender = titleData?.genType
          }
          else if (name === "PassportIssueCountryCode") {
            obj[name] = e.target.value;
          }
          else {
            obj[name] = Number(e.target.value);
          }
        }
        return obj;
      });
      setInsertCollection((coll: any) => ({ ...coll, infantColl: [...infant] }));
    }
  }
  //#endregion

  //#region fullname textbox on change for collection
  const handleOnChange = (coll: any, name: any, value: any, id: any) => {
    setFormError({});
    if (coll === 'adult') {
      const adult = insertCollection?.adultColl?.map((obj: any) => {
        if (obj?.id === id) {
          obj[name] = value;
        }
        return obj;
      });
      setInsertCollection((coll: any) => ({ ...coll, adultColl: [...adult] }));
    }
    else if (coll === 'child') {
      const child = insertCollection?.childColl?.map((obj: any) => {
        if (obj?.id === id) {
          obj[name] = value;
        }
        return obj;
      });
      setInsertCollection((coll: any) => ({ ...coll, childColl: [...child] }));
    }
    else if (coll === 'infant') {
      const infant = insertCollection?.infantColl?.map((obj: any) => {
        if (obj?.id === id) {
          obj[name] = value;
        }
        return obj;
      });
      setInsertCollection((coll: any) => ({ ...coll, infantColl: [...infant] }));
    }
  }
  //#endregion

  //#region date of birth and expiry date on chnage for collection
  const handleDateChange = (coll: any, name: any, e: any, id: any) => {
    setFormError({});
    if (coll === 'adult') {
      const adult = insertCollection?.adultColl?.map((obj: any) => {
        if (obj?.id === id) {
          if (name === 'tempDOB') {
            obj.DateOfBirth = e.target.value ? formatDate(e.target.value) + "T00:00:00" : null;
            obj.tempDOB = e.target.value ? formatDate(e.target.value) : "";
            obj.Age = e.target.value ? calculateAge(e.target.value) : "";
          }
          else if (name === 'tempExpiryDate') {
            obj.PassportExpiry = e.target.value ? formatDate(e.target.value) + "T00:00:00" : null;
            obj.tempExpiryDate = e.target.value ? formatDate(e.target.value) : "";
          }
          else if (name === 'tempPassportIssueDate') {
            obj.PassportIssueDate = e.target.value ? formatDate(e.target.value) + "T00:00:00" : null;
            obj.tempPassportIssueDate = e.target.value ? formatDate(e.target.value) : "";
          }
        }
        return obj;
      });
      setInsertCollection((coll: any) => ({ ...coll, adultColl: [...adult] }));
    }
    if (coll === 'child') {
      const child = insertCollection?.childColl?.map((obj: any) => {
        if (obj?.id === id) {
          if (name === 'tempDOB') {
            obj.DateOfBirth = e.target.value ? formatDate(e.target.value) + "T00:00:00" : null;
            obj.tempDOB = e.target.value ? formatDate(e.target.value) : "";
            obj.Age = e.target.value ? calculateAge(e.target.value) : "";
          }
          else if (name === 'tempExpiryDate') {
            obj.PassportExpiry = e.target.value ? formatDate(e.target.value) + "T00:00:00" : null;
            obj.tempExpiryDate = e.target.value ? formatDate(e.target.value) : "";
          }
          else if (name === 'tempPassportIssueDate') {
            obj.PassportIssueDate = e.target.value ? formatDate(e.target.value) + "T00:00:00" : null;
            obj.tempPassportIssueDate = e.target.value ? formatDate(e.target.value) : "";
          }
        }
        return obj;
      });
      setInsertCollection((coll: any) => ({ ...coll, childColl: [...child] }));
    }
    if (coll === 'infant') {
      const infant = insertCollection?.infantColl?.map((obj: any) => {
        if (obj?.id === id) {
          if (name === 'tempDOB') {
            obj.DateOfBirth = e.target.value ? formatDate(e.target.value) + "T00:00:00" : null;
            obj.tempDOB = e.target.value ? formatDate(e.target.value) : "";
            obj.Age = e.target.value ? calculateAge(e.target.value) : "";
          }
          else if (name === 'tempExpiryDate') {
            obj.PassportExpiry = e.target.value ? formatDate(e.target.value) + "T00:00:00" : null;
            obj.tempExpiryDate = e.target.value ? formatDate(e.target.value) : "";
          }
          else if (name === 'tempPassportIssueDate') {
            obj.PassportIssueDate = e.target.value ? formatDate(e.target.value) + "T00:00:00" : null;
            obj.tempPassportIssueDate = e.target.value ? formatDate(e.target.value) : "";
          }
        }
        return obj;
      });
      setInsertCollection((coll: any) => ({ ...coll, infantColl: [...infant] }));
    }
  }
  //#endregion

  //#region contact detail on change
  const onChangeContactDetail = (name: any, value: any) => {
    setFormError({});
    setFormValue((form: any) => ({ ...form, [name]: value }));
  }
  //#endregion

  //#region other textbox on change
  const onChange = (name: any, value: any) => {
    setFormError({});
    setFormValue((form: any) => ({ ...form, [name]: value }));
    let coll = {};
    Object.keys(insertCollection)?.map((obj) => {
      if (insertCollection[obj]?.length > 0) {
        coll = {
          ...coll,
          [obj]: [...insertCollection[obj]?.map((item: any) => {
            item[name] = value;
            return item;
          })]
        }
      }
    });
    setInsertCollection(coll)
  }
  //#endregion

  //#region other checkbox on change
  const handleChecked = (name: any, e: any) => {
    setFormError({});
    setFormValue((form: any) => ({ ...form, [name]: e.target.checked, GSTNumber: '', GSTCompanyName: '', GSTCompanyContactNumber: '', GSTCompanyEmail: '', GSTCompanyAddress: '' }));
    let coll = {};
    Object.keys(insertCollection)?.map((obj) => {
      if (insertCollection[obj]?.length > 0) {
        coll = {
          ...coll,
          [obj]: [...insertCollection[obj]?.map((item: any) => {
            item.GSTNumber = '';
            item.GSTCompanyName = '';
            item.GSTCompanyEmail = '';
            item.GSTCompanyContactNumber = '';
            item.GSTCompanyAddress = '';
            return item;
          })]
        }
      }
    });
    setInsertCollection(coll)
  }
  //#endregion

  //#region check validations function

  function checkDuplicatePassengers(data: any) {
    const map = new Map();

    function processList(list: any, type: any) {
      if (!Array.isArray(list)) return;

      list.forEach(function (pax, index) {
        const firstName = (pax.FirstName || "").trim().toLowerCase();
        const lastName = (pax.LastName || "").trim().toLowerCase();

        if (!firstName || !lastName) return; // ignore empty

        const fullNameKey = firstName + " " + lastName;

        if (!map.has(fullNameKey)) {
          map.set(fullNameKey, {
            name: pax.FirstName + " " + pax.LastName,
            occurrences: []
          });
        }

        map.get(fullNameKey).occurrences.push({
          type: type,
          index: index + 1 // user friendly index
        });
      });
    }

    processList(data.adultColl, "Adult");
    processList(data.childColl, "Child");
    processList(data.infantColl, "Infant");

    // return only duplicates
    return Array.from(map.values()).filter(function (entry) {
      return entry.occurrences.length > 1;
    });
  }

  const validateData = () => {
    let status = true;
    let error: any = {};
    let destinationDateForValid = flightFareQouteData?.[isDomRtn]?.response?.results?.segments[flightFareQouteData?.[isDomRtn]?.response?.results?.segments?.length - 1]?.[flightFareQouteData?.[isDomRtn]?.response?.results?.segments[flightFareQouteData?.[isDomRtn]?.response?.results?.segments?.length - 1].length - 1]?.destination?.arrTime
    if (insertCollection?.adultColl?.filter((item: any) => item?.IsLeadPax === true)?.length <= 0) {
      error['flightleadAdult'] = "Please select Lead.";
      status = false;
    }


    insertCollection?.adultColl?.map((obj: any, index: any) => {
      if (obj?.TitleId === 0) {
        error[`flightTitleSelectAdult${index + 1}`] = "Input is mandatory.";
        status = false;
      }

      // if (obj?.FullName === "") {
      //   error[`flightFullNameAdult${index + 1}`] = "Cannot leave blank. Please provide your full name.";
      //   status = false;
      // }

      if (obj?.FirstName?.trim()?.length <= 0) {
        error[`flightFirstNameAdult${index + 1}`] = "Cannot leave blank, input is mandatory.";
        status = false;
      }
      if (obj?.FirstName && obj?.FirstName?.trim()?.length < 2) {
        error[`flightFirstNameAdult${index + 1}`] = "Please enter valid Name";
        status = false;
      }

      if (obj?.LastName?.trim()?.length <= 0) {
        error[`flightLastNameAdult${index + 1}`] = "Cannot leave blank, input is mandatory.";
        status = false;
      }
      if (obj?.LastName && obj?.LastName?.trim()?.length < 2) {
        error[`flightLastNameAdult${index + 1}`] = "Please enter valid Name";
        status = false;
      }

      if (obj?.FirstName?.trim() === obj?.LastName?.trim()) {
        error[`flightFirstNameAdult${index + 1}`] = "First & Last name cannot be same.";
        status = false;
      }
      if (obj?.FirstName?.trim() === obj?.LastName?.trim()) {
        error[`flightLastNameAdult${index + 1}`] = "First & Last name cannot be same.";
        status = false;
      }

      // if (obj?.Gender === 0) {
      //   error[`flightGenderAdult${index + 1}`] = "Cannot leave blank, Please select your gender.";
      //   status = false;
      // }

      if (obj?.DateOfBirth === null) {
        // error[`flightdateOfBirthAdult${index + 1}`] = "Cannot leave blank, Please select Date Of Birth.";
        error[`flightdateOfBirthAdult${index + 1}`] = "Input is mandatory.";
        status = false;
      }
      if (obj?.DateOfBirth !== null && calculateDOB(formatDate(obj?.DateOfBirth), formatDate(new Date()), 12, 0, false, false)) {
        error[`flightdateOfBirthAdult${index + 1}`] = "Please provide valid DOB.";
        status = false;
      }
      if (obj?.CountryId === 0) {
        error[`flightCountryAdult${index + 1}`] = "Cannot leave blank, please select country.";
        status = false;
      }
      // city validation
      if (obj?.AirportLocationId === 0) {
        error[`flightCityAdult${index + 1}`] = "Cannot leave blank, please select city.";
        status = false;
      }
      if (obj?.ContactNo?.trim()?.length <= 0) {
        error[`flightContactNoAdult${index + 1}`] = "Cannot leave blank, please provide mobile number.";
        status = false;
      }
      if (obj.Email?.trim()?.length <= 0) {
        error[`flightEmailIdAdult${index + 1}`] = "Cannot leave blank, please provide email ID.";
        status = false;
      }
      if (obj?.Email && !isValidEmail(obj?.Email)) {
        error[`flightEmailIdAdult${index + 1}`] = "Please enter valid email ID.";
        status = false;
      }
      if (obj?.PassportNo?.length > 0 && (obj?.PassportNo?.trim()?.length < 6 || obj?.PassportNo?.trim()?.length > 10)) {
        error[`flightPassportNumberAdult${index + 1}`] = "Please enter valid  passport number.";
        status = false;
      }

      if (isInternational || (!isInternational && obj?.CountryId !== 1)) {
        if (obj?.PassportNo?.trim()?.length <= 0) {
          error[`flightPassportNumberAdult${index + 1}`] = "Cannot leave blank, please provide your passport number.";
          status = false;
        } else if (obj?.PassportNo?.trim()?.length > 0 && (obj?.PassportNo?.trim()?.length < 6 || obj?.PassportNo?.trim()?.length > 10)) {
          error[`flightPassportNumberAdult${index + 1}`] = "Please enter valid passport number.";
          status = false;
        }

        if (obj?.tempPassportIssueDate === "") {
          error[`flightPassportIssueDateAdult${index + 1}`] = "Cannot leave blank, please provide issuance date.";
          status = false;
        }
        else if (obj?.tempPassportIssueDate?.length > 0 && obj.DateOfBirth?.trim()?.length > 0 && !(new Date(obj.DateOfBirth) < new Date(obj.tempPassportIssueDate))) {
          error[`flightPassportIssueDateAdult${index + 1}`] = "Please enter valid passport issuance date.";
          status = false;
        }

        if (obj?.tempExpiryDate === "") {
          error[`flightPassportExpiryAdult${index + 1}`] = "Cannot leave blank, please provide expiry date.";
          status = false;
        } else if (new Date() > new Date(obj?.tempExpiryDate)) {
          error[`flightPassportExpiryAdult${index + 1}`] = "Please enter valid passport expiry date.";
          status = false;
        } else if (obj?.tempExpiryDate?.length > 0 && obj.tempPassportIssueDate !== "" && !(new Date(obj.tempPassportIssueDate) < new Date(obj.tempExpiryDate))) {
          error[`flightPassportExpiryAdult${index + 1}`] = "Please enter valid passport expiry date.";
          status = false;
        } else if (obj?.tempExpiryDate?.length > 0 && destinationDateForValid && !(new Date(destinationDateForValid) < new Date(obj.tempExpiryDate))) {
          error[`flightPassportExpiryAdult${index + 1}`] = "Please enter valid passport expiry date.";
          status = false;
        }

        if (obj?.PassportIssueCountryCode === "") {
          error[`flightPassportIssueCountryCodeAdult${index + 1}`] = "Cannot leave blank, please select passport issuance country.";
          status = false;
        }
      } else if (obj?.PassportNo?.trim()?.length > 0 || obj?.tempPassportIssueDate !== "" || obj?.tempExpiryDate !== "" || obj?.PassportIssueCountryCode !== "") {
        if (obj?.PassportNo?.trim()?.length <= 0) {
          error[`flightPassportNumberAdult${index + 1}`] = "Cannot leave blank, please provide your passport number.";
          status = false;
        } else if (obj?.PassportNo?.trim()?.length > 0 && (obj?.PassportNo?.trim()?.length < 6 || obj?.PassportNo?.trim()?.length > 10)) {
          error[`flightPassportNumberAdult${index + 1}`] = "Please enter valid passport number.";
          status = false;
        }

        if (obj?.tempPassportIssueDate === "") {
          error[`flightPassportIssueDateAdult${index + 1}`] = "Cannot leave blank, please provide issuance date.";
          status = false;
        } else if (obj?.tempPassportIssueDate?.length > 0 && !(new Date(obj.DateOfBirth) < new Date(obj.tempPassportIssueDate))) {
          error[`flightPassportIssueDateAdult${index + 1}`] = "Please enter valid passport issuance date.";
          status = false;
        }

        if (obj?.tempExpiryDate === "") {
          error[`flightPassportExpiryAdult${index + 1}`] = "Cannot leave blank, please provide expiry date.";
          status = false;
        } else if (obj?.tempExpiryDate?.length > 0 && !(new Date(obj.tempPassportIssueDate) < new Date(obj.tempExpiryDate))) {
          error[`flightPassportExpiryAdult${index + 1}`] = "Please enter valid passport expiry date.";
          status = false;
        } else if (obj?.tempExpiryDate?.length > 0 && !(new Date(destinationDateForValid) < new Date(obj.tempExpiryDate))) {
          error[`flightPassportExpiryAdult${index + 1}`] = "Please enter valid passport expiry date.";
          status = false;
        }

        if (obj?.PassportIssueCountryCode === "") {
          error[`flightPassportIssueCountryCodeAdult${index + 1}`] = "Cannot leave blank, please select passport issuance country.";
          status = false;
        }
      }

      if (obj?.AddressLine1 === "") {
        error[`flightAddress1Adult${index + 1}`] = "Kindly provide address.";
        status = false;
      }
    });

    insertCollection?.childColl?.map((obj: any, index: any) => {
      if (obj?.TitleId === 0) {
        error[`flightTitleSelectChild${index + 1}`] = "Input is mandatory.";
        status = false;
      }
      // if (obj?.FullName === "") {
      //   error[`flightFullNameChild${index + 1}`] = "Cannot leave blank. Please provide your full name.";
      //   status = false;
      // }
      if (obj?.FirstName?.trim()?.length <= 0) {
        error[`flightFirstNameChild${index + 1}`] = "Cannot leave blank, input is mandatory.";
        status = false;
      }
      if (obj?.FirstName && obj?.FirstName?.trim()?.length < 2) {
        error[`flightFirstNameChild${index + 1}`] = "Please enter valid Name";
        status = false;
      }
      if (obj?.LastName?.trim()?.length <= 0) {
        error[`flightLastNameChild${index + 1}`] = "Cannot leave blank, input is mandatory.";
        status = false;
      }
      if (obj?.LastName && obj?.LastName?.trim()?.length < 2) {
        error[`flightLastNameChild${index + 1}`] = "Please enter valid Name";
        status = false;
      }

      if (obj?.FirstName?.trim() === obj?.LastName?.trim()) {
        error[`flightFirstNameChild${index + 1}`] = "First & Last name cannot be same.";
        error[`flightLastNameChild${index + 1}`] = "First & Last name cannot be same.";
        status = false;
      }
      // if (obj?.Gender === 0) {
      //   error[`flightGenderChild${index + 1}`] = "Cannot leave blank, Please select your gender.";
      //   status = false;
      // }
      if (obj?.DateOfBirth === null) {
        // error[`flightdateOfBirthChild${index + 1}`] = "Cannot leave blank, Please select Date Of Birth.";
        error[`flightdateOfBirthChild${index + 1}`] = "Input is mandatory.";
        status = false;
      }
      if (obj?.DateOfBirth !== null && calculateDOB(formatDate(obj?.DateOfBirth), formatDate(new Date()), 2, 12, false, true)) {
        error[`flightdateOfBirthChild${index + 1}`] = "Please provide valid DOB.";
        status = false;
      }
      if (obj?.PassportNo?.length > 0 && (obj?.PassportNo?.trim()?.length < 6 || obj?.PassportNo?.trim()?.length > 10)) {
        error[`flightPassportNumberChild${index + 1}`] = "Please enter valid  passport number.";
        status = false;
      }
      if (isInternational || (!isInternational && obj?.CountryId !== 1)) {
        if (obj?.PassportNo?.trim()?.length <= 0) {
          error[`flightPassportNumberChild${index + 1}`] = "Cannot leave blank, please provide your passport number.";
          status = false;
        } else if (obj?.PassportNo?.trim()?.length > 0 && (obj?.PassportNo?.trim()?.length < 6 || obj?.PassportNo?.trim()?.length > 10)) {
          error[`flightPassportNumberChild${index + 1}`] = "Please enter valid passport number.";
          status = false;
        }

        if (obj?.tempPassportIssueDate === "") {
          error[`flightPassportIssueDateChild${index + 1}`] = "Cannot leave blank, please provide issuance date.";
          status = false;
        } else if (obj?.tempPassportIssueDate?.length > 0 && !(new Date(obj.DateOfBirth) < new Date(obj.tempPassportIssueDate))) {
          error[`flightPassportIssueDateChild${index + 1}`] = "Please enter valid passport issuance date.";
          status = false;
        }

        if (obj?.tempExpiryDate === "") {
          error[`flightPassportExpiryChild${index + 1}`] = "Cannot leave blank, please provide expiry date.";
          status = false;
        } else if (obj?.tempExpiryDate?.length > 0 && !(new Date(obj.tempPassportIssueDate) < new Date(obj.tempExpiryDate))) {
          error[`flightPassportExpiryChild${index + 1}`] = "Please enter valid passport expiry date.";
          status = false;
        } else if (obj?.tempExpiryDate?.length > 0 && !(new Date(destinationDateForValid) < new Date(obj.tempExpiryDate))) {
          error[`flightPassportExpiryChild${index + 1}`] = "Please enter valid passport expiry date.";
          status = false;
        }

        if (obj?.PassportIssueCountryCode === "") {
          error[`flightPassportIssueCountryCodeChild${index + 1}`] = "Cannot leave blank, please select passport issuance country.";
          status = false;
        }
      } else if (obj?.PassportNo?.trim()?.length > 0 || obj?.tempPassportIssueDate !== "" || obj?.tempExpiryDate !== "" || obj?.PassportIssueCountryCode !== "") {

        if (obj?.PassportNo?.trim()?.length <= 0) {
          error[`flightPassportNumberChild${index + 1}`] = "Cannot leave blank, please provide your passport number.";
          status = false;
        } else if (obj?.PassportNo?.trim()?.length > 0 && (obj?.PassportNo?.trim()?.length < 6 || obj?.PassportNo?.trim()?.length > 10)) {
          error[`flightPassportNumberChild${index + 1}`] = "Please enter valid passport number.";
          status = false;
        }

        if (obj?.tempPassportIssueDate === "") {
          error[`flightPassportIssueDateChild${index + 1}`] = "Cannot leave blank, please provide issuance date.";
          status = false;
        } else if (obj?.tempPassportIssueDate?.length > 0 && !(new Date(obj.DateOfBirth) < new Date(obj.tempPassportIssueDate))) {
          error[`flightPassportIssueDateChild${index + 1}`] = "Please enter valid passport issuance date.";
          status = false;
        }

        if (obj?.tempExpiryDate === "") {
          error[`flightPassportExpiryChild${index + 1}`] = "Cannot leave blank, please provide expiry date.";
          status = false;
        } else if (obj?.tempExpiryDate?.length > 0 && !(new Date(obj.tempPassportIssueDate) < new Date(obj.tempExpiryDate))) {
          error[`flightPassportExpiryChild${index + 1}`] = "Please enter valid passport expiry date.";
          status = false;
        } else if (obj?.tempExpiryDate?.length > 0 && !(new Date(destinationDateForValid) < new Date(obj.tempExpiryDate))) {
          error[`flightPassportExpiryChild${index + 1}`] = "Please enter valid passport expiry date.";
          status = false;
        }

        if (obj?.PassportIssueCountryCode === "") {
          error[`flightPassportIssueCountryCodeChild${index + 1}`] = "Cannot leave blank, please select passport issuance country.";
          status = false;
        }
      }


      if (obj?.AddressLine1 === "") {
        error[`flightAddress1Child${index + 1}`] = "Kindly provide address.";
        status = false;
      }
    });

    insertCollection?.infantColl?.map((obj: any, index: any) => {
      if (obj?.TitleId === 0) {
        error[`flightTitleSelectInfant${index + 1}`] = "Input is mandatory.";
        status = false;
      }
      // if (obj?.FullName === "") {
      //   error[`flightFullNameInfant${index + 1}`] = "Cannot leave blank. Please provide your full name.";
      //   status = false;
      // }
      if (obj?.FirstName?.trim()?.length <= 0) {
        error[`flightFirstNameInfant${index + 1}`] = "Cannot leave blank, input is mandatory.";
        status = false;
      }
      if (obj?.FirstName && obj?.FirstName?.trim()?.length < 2) {
        error[`flightFirstNameInfant${index + 1}`] = "Please enter valid Name";
        status = false;
      }
      if (obj?.LastName?.trim()?.length <= 0) {
        error[`flightLastNameInfant${index + 1}`] = "Cannot leave blank, input is mandatory.";
        status = false;
      }
      if (obj?.LastName && obj?.LastName?.trim()?.length < 2) {
        error[`flightLastNameInfant${index + 1}`] = "Please enter valid Name";
        status = false;
      }
      if (obj?.FirstName?.trim() === obj?.LastName?.trim()) {
        error[`flightFirstNameInfant${index + 1}`] = "First & Last name cannot be same.";
        error[`flightLastNameInfant${index + 1}`] = "First & Last name cannot be same.";
        status = false;
      }
      // if (obj?.Gender === 0) {
      //   error[`flightGenderInfant${index + 1}`] = "Cannot leave blank, Please select your gender.";
      //   status = false;
      // }
      if (obj?.DateOfBirth === null) {
        // error[`flightdateOfBirthInfant${index + 1}`] = "Cannot leave blank, Please select Date Of Birth.";
        error[`flightdateOfBirthInfant${index + 1}`] = "Input is mandatory.";
        status = false;
      }
      if (obj?.DateOfBirth !== null && calculateDOB(formatDate(obj?.DateOfBirth), formatDate(new Date()), 0, 2, true, true)) {
        error[`flightdateOfBirthInfant${index + 1}`] = "Please provide valid DOB.";
        status = false;
      }
      if (obj?.PassportNo?.length > 0 && (obj?.PassportNo?.trim()?.length < 6 || obj?.PassportNo?.trim()?.length > 10)) {
        error[`flightPassportNumberInfant${index + 1}`] = "Please enter valid  passport number.";
        status = false;
      }
      if (isInternational || (!isInternational && obj?.CountryId !== 1)) {

        if (obj?.PassportNo?.trim()?.length <= 0) {
          error[`flightPassportNumberInfant${index + 1}`] = "Cannot leave blank, please provide your passport number.";
          status = false;
        } else if (obj?.PassportNo?.trim()?.length > 0 && (obj?.PassportNo?.trim()?.length < 6 || obj?.PassportNo?.trim()?.length > 10)) {
          error[`flightPassportNumberInfant${index + 1}`] = "Please enter valid passport number.";
          status = false;
        }

        if (obj?.tempPassportIssueDate === "") {
          error[`flightPassportIssueDateInfant${index + 1}`] = "Cannot leave blank, please provide issuance date.";
          status = false;
        } else if (obj?.tempPassportIssueDate?.length > 0 && !(new Date(obj.DateOfBirth) < new Date(obj.tempPassportIssueDate))) {
          error[`flightPassportIssueDateInfant${index + 1}`] = "Please enter valid passport issuance date.";
          status = false;
        }

        if (obj?.tempExpiryDate === "") {
          error[`flightPassportExpiryInfant${index + 1}`] = "Cannot leave blank, please provide expiry date.";
          status = false;
        } else if (obj?.tempExpiryDate?.length > 0 && !(new Date(obj.tempPassportIssueDate) < new Date(obj.tempExpiryDate))) {
          error[`flightPassportExpiryInfant${index + 1}`] = "Please enter valid passport expiry date.";
          status = false;
        } else if (obj?.tempExpiryDate?.length > 0 && !(new Date(destinationDateForValid) < new Date(obj.tempExpiryDate))) {
          error[`flightPassportExpiryInfant${index + 1}`] = "Please enter valid passport expiry date.";
          status = false;
        }

        if (obj?.PassportIssueCountryCode === "") {
          error[`flightPassportIssueCountryCodeInfant${index + 1}`] = "Cannot leave blank, please select passport issuance country.";
          status = false;
        }
      } else if (obj?.PassportNo?.trim()?.length > 0 || obj?.tempPassportIssueDate !== "" || obj?.tempExpiryDate !== "" || obj?.PassportIssueCountryCode !== "") {

        if (obj?.PassportNo?.trim()?.length <= 0) {
          error[`flightPassportNumberInfant${index + 1}`] = "Cannot leave blank, please provide your passport number.";
          status = false;
        } else if (obj?.PassportNo?.trim()?.length > 0 && (obj?.PassportNo?.trim()?.length < 6 || obj?.PassportNo?.trim()?.length > 10)) {
          error[`flightPassportNumberInfant${index + 1}`] = "Please enter valid passport number.";
          status = false;
        }

        if (obj?.tempPassportIssueDate === "") {
          error[`flightPassportIssueDateInfant${index + 1}`] = "Cannot leave blank, please provide issuance date.";
          status = false;
        } else if (obj?.tempPassportIssueDate?.length > 0 && !(new Date(obj.DateOfBirth) < new Date(obj.tempPassportIssueDate))) {
          error[`flightPassportIssueDateInfant${index + 1}`] = "Please enter valid passport issuance date.";
          status = false;
        }

        if (obj?.tempExpiryDate === "") {
          error[`flightPassportExpiryInfant${index + 1}`] = "Cannot leave blank, please provide expiry date.";
          status = false;
        } else if (obj?.tempExpiryDate?.length > 0 && !(new Date(obj.tempPassportIssueDate) < new Date(obj.tempExpiryDate))) {
          error[`flightPassportExpiryInfant${index + 1}`] = "Please enter valid passport expiry date.";
          status = false;
        } else if (obj?.tempExpiryDate?.length > 0 && !(new Date(destinationDateForValid) < new Date(obj.tempExpiryDate))) {
          error[`flightPassportExpiryInfant${index + 1}`] = "Please enter valid passport expiry date.";
          status = false;
        }

        if (obj?.PassportIssueCountryCode === "") {
          error[`flightPassportIssueCountryCodeInfant${index + 1}`] = "Cannot leave blank, please select passport issuance country.";
          status = false;
        }
      }

      if (obj?.AddressLine1 === "") {
        error[`flightAddress1Infant${index + 1}`] = "Kindly provide address.";
        status = false;
      }
    });

    // check name duplicetion
    const duplicates = checkDuplicatePassengers(insertCollection);

    if (duplicates.length > 0) {
      let errorMessage = "Passenger name cannot be same.<br/>";

      // show massage with identify where is duplicate, currently code is comment is requirement come then uncommet the code

      // duplicates.forEach(function (d) {
      //   const locations = d.occurrences
      //     .map(function (o) {
      //       return o.type + " (" + o.index + ")";
      //     })
      //     .join(", ");

      //  errorMessage += d.name + " → " + locations + "<br/><br/>";
      // });

      dispatch({ type: 'ALERTING', message: errorMessage });
      status = false;
      return;
    }

    if (formValue?.CountryId <= 0) {
      error["CountryId"] = "Cannot leave blank, please select country code.";
      status = false;
    }
    if (formValue?.AirportLocationId <= 0) {
      error["AirportLocationId"] = "Cannot leave blank, please select city.";
      status = false;
    }
    if (formValue?.MobileNo?.trim()?.length <= 0) {
      error["MobileNo"] = "Cannot leave blank, please provide mobile number.";
      status = false;
    }
    if (formValue?.Email?.trim()?.length <= 0) {
      error["Email"] = "Cannot leave blank, please provide email ID.";
      status = false;
    }
    if (formValue?.Email && !isValidEmail(formValue?.Email)) {
      error["Email"] = "Please enter valid email ID.";
      status = false;
    }

    if (flightFareQouteData?.[0]?.response?.results?.isGSTMandatory === true && formValue?.IsGST === false) {
      dispatch({ type: 'ALERTING', message: 'Please provide GST details' });
      status = false;
    }

    if (formValue?.IsGST === true) {

      if (formValue?.GSTNumber?.trim()?.length === 0) {
        error["GSTNumber"] = "Cannot leave blank, please provide GST Number.";
        status = false;
      }
      if (formValue?.GSTNumber && !gstinregex.test(formValue?.GSTNumber)) {
        error["GSTNumber"] = "Please enter valid GST Number.";
        status = false;
      }
      if (formValue?.GSTNumber?.trim()?.length > 0 && formValue?.GSTCompanyName?.trim()?.length <= 0) {
        error["GSTCompanyName"] = "Cannot leave blank, please provide GST Company Name.";
        status = false;
      }
      if (formValue?.GSTNumber?.trim()?.length > 0 && formValue?.GSTCompanyContactNumber?.trim()?.length <= 0) {
        error["GSTCompanyContactNumber"] = "Cannot leave blank, please provide GST Company Contact Number.";
        status = false;
      }
      else if (formValue?.GSTNumber?.trim()?.length > 0 && formValue?.GSTCompanyContactNumber?.trim()?.length > 0 && formValue?.GSTCompanyContactNumber?.trim()?.length < 10) {
        error["GSTCompanyContactNumber"] = "Please provide valid GST Company Contact Number.";
        status = false;
      }
      if (formValue?.GSTNumber?.trim()?.length > 0 && formValue?.GSTCompanyEmail?.trim()?.length <= 0) {
        error["GSTCompanyEmail"] = "Cannot leave blank, please provide GST Company Email.";
        status = false;
      }
      if (formValue?.GSTCompanyEmail && !isValidEmail(formValue?.GSTCompanyEmail)) {
        error["GSTCompanyEmail"] = "Please enter valid email ID.";
        status = false;
      }
      if (formValue?.GSTNumber?.trim()?.length > 0 && formValue?.GSTCompanyAddress?.trim()?.length <= 0) {
        error["GSTCompanyAddress"] = "Cannot leave blank, please provide GST Company Address.";
        status = false;
      }
    }


    if (Object.keys(error)?.length > 0) {
      document.getElementById(Object.keys(error)[0])?.focus();
    }
    setFormError(error);
    return status;
  }
  //#endregion

  const handleContinue = async () => {
    if (validateData()) {
      dispatch(loaderActions.start());
      const statusoftoken = await verifytoken();
      if (statusoftoken) {
        const user: any = GetLocalStorage();
        if (location?.state !== null) {
          const fltbookid = decryptUrlDatapattern(location?.state?.BookingId)?.[isDomRtn];
          const data = {
            BookingId: fltbookid,
            UserId: user?.userMasterID,
            Passengers: allPassangersData(insertCollection, false),
          }
          const insertupdatetravellerdetails = await postUsersData("/customerui/v1/insertupdatetravellerdetails", data);
          if (insertupdatetravellerdetails?.status) {
            sessionStorage.setItem('passengers', JSON.stringify(data?.Passengers));
            sessionStorage.setItem('others', JSON.stringify(formValue));
            sessionStorage.setItem('isContinue', encryptUrlDatapattern(true));
            handlePage('payment');
            dispatch(loaderActions.end());
          }
          else {
            dispatch({ type: 'ALERTING', message: insertupdatetravellerdetails.message });
            dispatch(loaderActions.end());
          }
        }
        // else {}
      }
      else {
        dispatch(loaderActions.end());
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
      }
    }
  }


  return (
    <>
      <div className="row">
        <div className="detailContainer">

          <FlightReviewComponant isDomRtn={isDomRtn} UpdatedBookFlightData={UpdatedBookFlightData} flightData={flightFareQouteData} flightFareRuleData={flightFareRuleData} />

          <form action="" method="">
            {/* <!--Free medical Refund policy--> */}
            <div className="features">

              <div className="title pr">
                <i className="fa-solid fa-user-group"></i>
                <div>
                  <h4>Traveller Details</h4>
                  <p><b>NOTE : </b>Enter name as mentioned on your passport or Government approved ID proof. </p>
                </div>
              </div>
              <div className="detailDiv pt-3">
                <div id="travellerDetails">
                  {/* <!--Adult Traveller Form--> */}
                  {
                    insertCollection?.adultColl?.length > 0 &&
                    <h3 className="travellerTitle">ADULT (12 yrs+)</h3>
                  }
                  {
                    insertCollection?.adultColl?.map((obj: any, index: any) => {
                      return (
                        <div key={`adult${obj?.id}`} className="travellerDiv">
                          <h4 className="heading active">Adult {index + 1}</h4>
                          <div className="form">

                            <div className="row">

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-check mb-3 travellerLead">
                                  <input className="form-check-input" type="radio" disabled={isDomRtn === 1} name="Lead" id={`lead${index + 1}`} checked={obj?.IsLeadPax} onChange={(e) => handleLeadRadio(e, obj?.id)} />
                                  <label className="form-check-label" htmlFor={`lead${index + 1}`}>Lead</label>
                                </div>
                                {formError['flightleadAdult'] && <div className="text-danger f-14">{formError['flightleadAdult']}</div>}
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <select
                                    className="form-select"
                                    id={`flightTravelerNameAdult${index + 1}`}
                                    value={obj?.TravelerName}
                                    onChange={(e) => handleSelectSuggestion('adult', e, obj?.id)}
                                    disabled={isDomRtn === 1}
                                  >
                                    <option value={0}> Select Traveler Name </option>
                                    {
                                      dropdownData?.travellerList?.map((list: any) => {
                                        return (
                                          <option key={`travelerName${list?.UserMasterID}`} value={list?.UserMasterID}> {list?.FirstName} </option>
                                        )
                                      })
                                    }
                                  </select>
                                  <label htmlFor={`flightTravelerNameAdult${index + 1}`}>Traveler Name</label>
                                  {formError[`flightTravelerNameAdult${index + 1}`] && <div className="text-danger f-14">{formError[`flightTravelerNameAdult${index + 1}`]}</div>}
                                </div>
                              </div>

                              {/* <div className="col-xl-2 col-lg-3 col-md-2 col-sm-3"> */}
                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <select
                                    className="form-select"
                                    id={`flightTitleSelectAdult${index + 1}`}
                                    value={obj?.TitleId}
                                    onChange={(e) => handleSelect('adult', 'TitleId', e, obj?.id)}
                                    disabled={isDomRtn === 1}
                                  >
                                    <option value={0}> Select Title </option>
                                    {
                                      titleList?.map((obj) => {
                                        return (
                                          <option key={`title${obj?.value}`} value={obj?.value}> {obj?.label} </option>
                                        )
                                      })
                                    }
                                  </select>
                                  <label htmlFor={`flightTitleSelectAdult${index + 1}`}>Title</label>
                                  {formError[`flightTitleSelectAdult${index + 1}`] && <div className="text-danger f-14">{formError[`flightTitleSelectAdult${index + 1}`]}</div>}
                                </div>
                              </div>

                              {/* <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`flightFullNameAdult${index + 1}`}
                                    placeholder="Full Name"
                                    value={obj?.FullName}
                                    onChange={(e) => handleOnChange('adult', 'FullName', onlyAlphabets(e.target.value), obj?.id)}
                                    maxLength={150}
                                  />
                                  <label htmlFor={`flightFullNameAdult${index + 1}`}>Full Name</label>
                                  {formError[`flightFullNameAdult${index + 1}`] && <div className="text-danger f-14">{formError[`flightFullNameAdult${index + 1}`]}</div>}
                                </div>
                              </div> */}
                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`flightFirstNameAdult${index + 1}`}
                                    placeholder="First Name"
                                    value={obj?.FirstName}
                                    onChange={(e) =>
                                      e.target.value?.length <= 25 &&
                                      handleOnChange('adult', 'FirstName', AlphabetAllows(e.target.value), obj?.id)
                                    }
                                    maxLength={25}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightFirstNameAdult${index + 1}`}>First Name</label>
                                  {formError[`flightFirstNameAdult${index + 1}`] && <div className="text-danger f-14">{formError[`flightFirstNameAdult${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`flightLastNameAdult${index + 1}`}
                                    placeholder="Last Name"
                                    value={obj?.LastName}
                                    onChange={(e) =>
                                      e.target.value?.length <= 25 &&
                                      handleOnChange('adult', 'LastName', AlphabetAllows(e.target.value), obj?.id)
                                    }
                                    maxLength={25}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightLastNameAdult${index + 1}`}>Last Name</label>
                                  {formError[`flightLastNameAdult${index + 1}`] && <div className="text-danger f-14">{formError[`flightLastNameAdult${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6 mb-3">
                                {/* {
                                  genderList?.map((gender) => {
                                    return (
                                      <div key={`${gender?.label}${gender?.value}`} className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name={`flightAdult${index + 1}`}
                                          id={`flight${gender?.label}Adult${index + 1}`}
                                          value={gender?.value}
                                          checked={obj?.Gender === gender?.value}
                                          onChange={(e) => handleSelect('adult', 'Gender', e, obj?.id)}
                                          disabled
                                        />
                                        <label style={{ opacity: '1' }} className="form-check-label" htmlFor={`flight${gender?.label}Adult${index + 1}`}>
                                          {gender?.label}
                                        </label>
                                      </div>
                                    )
                                  })
                                } */}
                                {/* {formError[`flightGenderAdult${index + 1}`] && <div className="text-danger f-14">{formError[`flightGenderAdult${index + 1}`]}</div>} */}
                                <div className="form-floating">
                                  <select
                                    className="form-select"
                                    id={`flightgenderSelectAdult${index + 1}`}
                                    value={obj?.Gender}
                                    onChange={(e) => handleSelect('adult', 'Gender', e, obj?.id)}
                                    disabled
                                  >
                                    <option value={0}> Gender </option>
                                    {
                                      genderList?.map((obj) => {
                                        return (
                                          <option key={`gender${obj?.value}`} value={obj?.value}> {obj?.label} </option>
                                        )
                                      })
                                    }
                                  </select>
                                  <label htmlFor={`flightgenderSelectAdult${index + 1}`}>Gender</label>
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="date"
                                    className="form-control"
                                    id={`flightdateOfBirthAdult${index + 1}`}
                                    placeholder="Date of Birth"
                                    max={formatDate(new Date()) || ''}
                                    min={formatDate(new Date(minDOB)) || ''}
                                    value={obj.tempDOB}
                                    onChange={(e: any) => handleDateChange('adult', 'tempDOB', e, obj?.id)}
                                    onClick={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    onKeyDown={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightdateOfBirthAdult${index + 1}`}>Date of Birth</label>
                                  {formError[`flightdateOfBirthAdult${index + 1}`] && <div className="text-danger f-14">{formError[`flightdateOfBirthAdult${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`flightAgeAdult${index + 1}`}
                                    placeholder="Age"
                                    value={obj?.Age}
                                    onChange={(e) => handleOnChange('adult', 'Age', e.target.value, obj?.id)}
                                    disabled
                                  />
                                  <label htmlFor={`flightAgeAdult${index + 1}`}>Age</label>
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <select
                                    className="form-select"
                                    id={`flightCountryAdult${index + 1}`}
                                    value={obj?.CountryId}
                                    onChange={(e) => handleSelect('adult', 'CountryId', e, obj?.id)}
                                    disabled={isDomRtn === 1}
                                  >
                                    <option value={0}> Select Country </option>
                                    {
                                      dropdownData?.countryList?.map((cnt: any) => {
                                        return (
                                          <option key={`country${cnt?.CountryId}`} value={cnt?.CountryId} > {cnt?.CountryName} {cnt?.ISDCode ? `(${cnt?.ISDCode})` : ''} </option>
                                        )
                                      })
                                    }
                                  </select>
                                  <label htmlFor={`flightCountryAdult${index + 1}`}>Country</label>
                                  {formError[`flightCountryAdult${index + 1}`] && <div className="text-danger f-14">{formError[`flightCountryAdult${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <select
                                    className="form-select"
                                    id={`flightCityAdult${index + 1}`}
                                    value={obj?.AirportLocationId}
                                    onChange={(e) => handleSelect('adult', 'AirportLocationId', e, obj?.id)}
                                    disabled={isDomRtn === 1}
                                  >
                                    <option value={0}> Select City </option>
                                    {
                                      dropdownData?.cityList?.filter((fil: any) => fil?.CountryId === Number(obj?.CountryId))?.map((city: any, index: any) => {
                                        return (
                                          <option key={`city${city?.AirportLocationId}`} value={city?.AirportLocationId} > {city?.City} </option>
                                        )
                                      })
                                    }
                                  </select>
                                  <label htmlFor={`flightCityAdult${index + 1}`}> City </label>
                                  {formError[`flightCityAdult${index + 1}`] && <div className="text-danger f-14">{formError[`flightCityAdult${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`flightContactNoAdult${index + 1}`}
                                    placeholder="Mobile No"
                                    value={obj?.ContactNo}
                                    onChange={(e) => handleOnChange('adult', 'ContactNo', onlyNumeric(e.target.value), obj?.id)}
                                    maxLength={25}
                                    disabled={isDomRtn === 1}
                                  />
                                  {formError?.[`flightContactNoAdult${index + 1}`] && <div className="text-danger f-14">{formError?.[`flightContactNoAdult${index + 1}`]}</div>}
                                  <label htmlFor={`flightContactNoAdult${index + 1}`}>Mobile Number</label>
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="email"
                                    className="form-control"
                                    id={`flightEmailIdAdult${index + 1}`}
                                    placeholder="email"
                                    value={obj?.Email}
                                    onChange={(e) => handleOnChange('adult', 'Email', e.target.value, obj?.id)}
                                    maxLength={150}
                                    disabled={isDomRtn === 1}
                                  />
                                  {formError?.[`flightEmailIdAdult${index + 1}`] && <div className="text-danger f-14">{formError?.[`flightEmailIdAdult${index + 1}`]}</div>}
                                  <label htmlFor={`flightEmailIdAdult${index + 1}`}>Email</label>
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`flightPassportNumberAdult${index + 1}`}
                                    placeholder="Passport Number"
                                    value={obj?.PassportNo}
                                    onChange={(e) => handleOnChange('adult', 'PassportNo', alphaNumeric(e.target.value), obj?.id)}
                                    maxLength={10}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightPassportNumberAdult${index + 1}`}>Passport number</label>
                                  {formError[`flightPassportNumberAdult${index + 1}`] && <div className="text-danger f-14">{formError[`flightPassportNumberAdult${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="date"
                                    className="form-control"
                                    id={`flightPassportIssueDateAdult${index + 1}`}
                                    placeholder="Passport Issuance Date"
                                    value={obj.tempPassportIssueDate}
                                    onChange={(e) => handleDateChange('adult', 'tempPassportIssueDate', e, obj?.id)}
                                    onClick={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    onKeyDown={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightPassportIssueDateAdult${index + 1}`}>Passport Issuance Date</label>
                                  {formError[`flightPassportIssueDateAdult${index + 1}`] && <div className="text-danger f-14">{formError[`flightPassportIssueDateAdult${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="date"
                                    className="form-control"
                                    id={`flightPassportExpiryAdult${index + 1}`}
                                    placeholder="Passport expiry date"
                                    value={obj.tempExpiryDate}
                                    onChange={(e) => handleDateChange('adult', 'tempExpiryDate', e, obj?.id)}
                                    onClick={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    onKeyDown={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightPassportExpiryAdult${index + 1}`}>Passport expiry date</label>
                                  {formError[`flightPassportExpiryAdult${index + 1}`] && <div className="text-danger f-14">{formError[`flightPassportExpiryAdult${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <select
                                    className="form-select"
                                    id={`flightPassportIssueCountryCodeAdult${index + 1}`}
                                    value={obj?.PassportIssueCountryCode}
                                    onChange={(e) => handleSelect('adult', 'PassportIssueCountryCode', e, obj?.id)}
                                    disabled={isDomRtn === 1}
                                  >
                                    <option value={""}> Select Issuance Country </option>
                                    {
                                      dropdownData?.countryList?.map((cnt: any) => {
                                        return (
                                          <option key={`issuecountry${cnt?.CountryId}`} value={cnt?.CountryCode} > {cnt?.CountryName} {cnt?.CountryCode ? `(${cnt?.CountryCode})` : ''} </option>
                                        )
                                      })
                                    }
                                  </select>
                                  <label htmlFor={`flightPassportIssueCountryCodeAdult${index + 1}`}>Passport Issuance Country</label>
                                  {formError[`flightPassportIssueCountryCodeAdult${index + 1}`] && <div className="text-danger f-14">{formError[`flightPassportIssueCountryCodeAdult${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <textarea
                                    className="form-control"
                                    placeholder="AddressLine1"
                                    id={`flightAddress1Adult${index + 1}`}
                                    name='AddressLine1'
                                    value={obj?.AddressLine1}
                                    onChange={(e) => handleOnChange('adult', 'AddressLine1', e.target.value, obj?.id)}
                                    maxLength={250}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightAddress1Adult${index + 1}`}>Address Line 1</label>
                                  {formError[`flightAddress1Adult${index + 1}`] && <div className="text-danger f-14">{formError[`flightAddress1Adult${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <textarea
                                    className="form-control"
                                    placeholder="AddressLine2"
                                    id={`flightAddress2Adult${index + 1}`}
                                    name='AddressLine2'
                                    value={obj?.AddressLine2}
                                    onChange={(e) => handleOnChange('adult', 'AddressLine2', e.target.value, obj?.id)}
                                    maxLength={250}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightAddress2Adult${index + 1}`}>Address Line 2</label>
                                  {formError[`flightAddress2Adult${index + 1}`] && <div className="text-danger f-14">{formError[`flightAddress2Adult${index + 1}`]}</div>}
                                </div>
                              </div>

                            </div>
                            {/* <!--Frequent flyer preference Form--> */}
                            <button type="button" className='btn p-0'>
                              <h4 className={`frequentFlyer collapsed`} id={`flyerMealAdult${index + 1}`} data-bs-toggle="collapse" data-bs-target={`#flyerAdult${index + 1}`} >
                                <i className="fa-solid fa-circle-plus"></i> Frequent flyer number and Meal preference (optional)
                              </h4>
                            </button>
                            <div id={`flyerAdult${index + 1}`} className={`accordion-collapse collapse `}>
                              <div className="frequentDiv">
                                <div className="row">

                                  <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                    <div className="form-floating mb-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id={`flightFlyerNoAdult${index + 1}`}
                                        placeholder="Flyer No"
                                        value={obj?.FFNumber}
                                        onChange={(e) => handleOnChange('adult', 'FFNumber', alphaNumeric(e.target.value), obj?.id)}
                                        maxLength={50}
                                        disabled={isDomRtn === 1}
                                      />
                                      <label htmlFor={`flightFlyerNoAdult${index + 1}`}>Frequent flyer no.</label>
                                      {formError[`flightFlyerNoAdult${index + 1}`] && <div className="text-danger f-14">{formError[`flightFlyerNoAdult${index + 1}`]}</div>}
                                    </div>
                                  </div>

                                  <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                    <div className="form-floating mb-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id={`flightAirlineNameAdult${index + 1}`}
                                        placeholder="Airline Name"
                                        value={obj?.FFAirlineCode}
                                        onChange={(e) => handleOnChange('adult', 'FFAirlineCode', alphaNumeric(e.target.value), obj?.id)}
                                        maxLength={50}
                                        disabled={isDomRtn === 1}
                                      />
                                      <label htmlFor={`flightAirlineNameAdult${index + 1}`}>Airline Name</label>
                                      {formError[`flightAirlineNameAdult${index + 1}`] && <div className="text-danger f-14">{formError[`flightAirlineNameAdult${index + 1}`]}</div>}
                                    </div>
                                  </div>

                                  <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                    <div className="form-floating mb-3">
                                      <select
                                        className="form-select"
                                        id={`flightMealPreferenceAdult${index + 1}`}
                                        value={obj?.MealId}
                                        onChange={(e) => handleSelect('adult', 'MealId', e, obj?.id)}
                                        disabled={isDomRtn === 1}
                                      >
                                        <option value={0}> Select Meal Preference </option>
                                        {
                                          mealList?.map((obj) => {
                                            return (
                                              <option key={`meal${obj?.value}`} value={obj?.value}> {obj?.label} </option>
                                            )
                                          })
                                        }
                                      </select>
                                      <label htmlFor={`flightMealPreferenceAdult${index + 1}`}>Meal Preference</label>
                                      {formError[`flightMealPreferenceAdult${index + 1}`] && <div className="text-danger f-14">{formError[`flightMealPreferenceAdult${index + 1}`]}</div>}
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* <!--Frequent flyer preference Form--> */}
                          </div>
                        </div>
                      )
                    })
                  }

                  {/* <!--Adult Traveller Form--> */}


                  {/* <!--Child Traveller Form--> */}
                  {
                    insertCollection?.childColl?.length > 0 &&
                    <h3 className="travellerTitle">CHILD (2-12 Yrs)</h3>
                  }
                  {
                    insertCollection?.childColl?.map((obj: any, index: any) => {
                      return (
                        <div key={`child${obj?.id}`} className="travellerDiv">
                          <h4 className="heading active">Child {index + 1}</h4>
                          <div className="form">

                            <div className="row">

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <select
                                    className="form-select"
                                    id={`flightTravelerNameChild${index + 1}`}
                                    value={obj?.TravelerName}
                                    onChange={(e) => handleSelectSuggestion('child', e, obj?.id)}
                                    disabled={isDomRtn === 1}
                                  >
                                    <option value={0}> Select Traveler Name </option>
                                    {
                                      dropdownData?.travellerList?.map((list: any) => {
                                        return (
                                          <option key={`childtravelerName${list?.UserMasterID}`} value={list?.UserMasterID}> {list?.FirstName} </option>
                                        )
                                      })
                                    }
                                  </select>
                                  <label htmlFor={`flightTravelerNameChild${index + 1}`}>Traveler Name</label>
                                  {formError[`flightTravelerNameChild${index + 1}`] && <div className="text-danger f-14">{formError[`flightTravelerNameChild${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <select
                                    className="form-select"
                                    id={`flightTitleSelectChild${index + 1}`}
                                    value={obj?.TitleId}
                                    onChange={(e) => handleSelect('child', 'TitleId', e, obj?.id)}
                                    disabled={isDomRtn === 1}
                                  >
                                    <option value={0}> Select Title </option>
                                    {
                                      titleList?.map((obj) => {
                                        return (
                                          <option key={`title${obj?.value}`} value={obj?.value}> {obj?.label} </option>
                                        )
                                      })
                                    }
                                  </select>
                                  <label htmlFor={`flightTitleSelectChild${index + 1}`}>Title</label>
                                  {formError[`flightTitleSelectChild${index + 1}`] && <div className="text-danger f-14">{formError[`flightTitleSelectChild${index + 1}`]}</div>}
                                </div>
                              </div>

                              {/* <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`flightFullNameChild${index + 1}`}
                                    placeholder="Full Name"
                                    value={obj?.FullName}
                                    onChange={(e) => handleOnChange('child', 'FullName', onlyAlphabets(e.target.value), obj?.id)}
                                    maxLength={150}
                                  />
                                  <label htmlFor={`flightFullNameChild${index + 1}`}>Full Name</label>
                                  {formError[`flightFullNameChild${index + 1}`] && <div className="text-danger f-14">{formError[`flightFullNameChild${index + 1}`]}</div>}
                                </div>
                              </div> */}

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`flightFirstNameChild${index + 1}`}
                                    placeholder="First Name"
                                    value={obj?.FirstName}
                                    onChange={(e) =>
                                      e.target.value?.length <= 25 &&
                                      handleOnChange('child', 'FirstName', AlphabetAllows(e.target.value), obj?.id)
                                    }
                                    maxLength={25}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightFirstNameChild${index + 1}`}>First Name</label>
                                  {formError[`flightFirstNameChild${index + 1}`] && <div className="text-danger f-14">{formError[`flightFirstNameChild${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`flightLastNameChild${index + 1}`}
                                    placeholder="Last Name"
                                    value={obj?.LastName}
                                    onChange={(e) =>
                                      e.target.value?.length <= 25 &&
                                      handleOnChange('child', 'LastName', AlphabetAllows(e.target.value), obj?.id)
                                    }
                                    maxLength={25}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightLastNameChild${index + 1}`}>Last Name</label>
                                  {formError[`flightLastNameChild${index + 1}`] && <div className="text-danger f-14">{formError[`flightLastNameChild${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6 mb-3">
                                {/* {
                                  genderList?.map((gender) => {
                                    return (
                                      <div key={`${gender?.label}${gender?.value}`} className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name={`flightChild${index + 1}`}
                                          id={`flight${gender?.label}Child${index + 1}`}
                                          value={gender?.value}
                                          checked={obj?.Gender === gender?.value}
                                          onChange={(e) => handleSelect('child', 'Gender', e, obj?.id)}
                                          disabled
                                        />
                                        <label style={{ opacity: '1' }} className="form-check-label" htmlFor={`flight${gender?.label}Child${index + 1}`}>
                                          {gender?.label}
                                        </label>
                                      </div>
                                    )
                                  })
                                }
                                {formError[`flightGenderChild${index + 1}`] && <div className="text-danger f-14">{formError[`flightGenderChild${index + 1}`]}</div>} */}
                                <div className="form-floating">
                                  <select
                                    className="form-select"
                                    id={`flightgenderSelectChild${index + 1}`}
                                    value={obj?.Gender}
                                    onChange={(e) => handleSelect('child', 'Gender', e, obj?.id)}
                                    disabled
                                  >
                                    <option value={0}> Gender </option>
                                    {
                                      genderList?.map((obj) => {
                                        return (
                                          <option key={`gender${obj?.value}`} value={obj?.value}> {obj?.label} </option>
                                        )
                                      })
                                    }
                                  </select>
                                  <label htmlFor={`flightgenderSelectChild${index + 1}`}>Gender</label>
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="date"
                                    className="form-control"
                                    id={`flightdateOfBirthChild${index + 1}`}
                                    placeholder="Date of Birth"
                                    max={formatDate(new Date()) || ''}
                                    min={formatDate(new Date(minDOB)) || ''}
                                    value={obj.tempDOB}
                                    onChange={(e) => handleDateChange('child', 'tempDOB', e, obj?.id)}
                                    onClick={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    onKeyDown={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightdateOfBirthChild${index + 1}`}>Date of Birth</label>
                                  {formError[`flightdateOfBirthChild${index + 1}`] && <div className="text-danger f-14">{formError[`flightdateOfBirthChild${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`flightAgeChild${index + 1}`}
                                    placeholder="Age"
                                    value={obj?.Age}
                                    onChange={(e) => handleOnChange('adult', 'Age', e.target.value, obj?.id)}
                                    disabled
                                  />
                                  <label htmlFor={`flightAgeChild${index + 1}`}>Age</label>
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`flightPassportNumberChild${index + 1}`}
                                    placeholder="Passport Number"
                                    value={obj?.PassportNo}
                                    onChange={(e) => handleOnChange('child', 'PassportNo', alphaNumeric(e.target.value), obj?.id)}
                                    maxLength={10}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightPassportNumberChild${index + 1}`}>Passport number</label>
                                  {formError[`flightPassportNumberChild${index + 1}`] && <div className="text-danger f-14">{formError[`flightPassportNumberChild${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="date"
                                    className="form-control"
                                    id={`flightPassportIssueDateChild${index + 1}`}
                                    placeholder="Passport Issuance Date"
                                    value={obj.tempPassportIssueDate}
                                    onChange={(e) => handleDateChange('child', 'tempPassportIssueDate', e, obj?.id)}
                                    onClick={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    onKeyDown={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightPassportIssueDateChild${index + 1}`}>Passport Issuance Date</label>
                                  {formError[`flightPassportIssueDateChild${index + 1}`] && <div className="text-danger f-14">{formError[`flightPassportIssueDateChild${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="date"
                                    className="form-control"
                                    id={`flightPassportExpiryChild${index + 1}`}
                                    placeholder="Passport expiry date"
                                    value={obj.tempExpiryDate}
                                    onChange={(e) => handleDateChange('child', 'tempExpiryDate', e, obj?.id)}
                                    onClick={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    onKeyDown={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightPassportExpiryChild${index + 1}`}>Passport expiry date</label>
                                  {formError[`flightPassportExpiryChild${index + 1}`] && <div className="text-danger f-14">{formError[`flightPassportExpiryChild${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <select
                                    className="form-select"
                                    id={`flightPassportIssueCountryCodeChild${index + 1}`}
                                    value={obj?.PassportIssueCountryCode}
                                    onChange={(e) => handleSelect('child', 'PassportIssueCountryCode', e, obj?.id)}
                                    disabled={isDomRtn === 1}
                                  >
                                    <option value={""}> Select Issuance Country </option>
                                    {
                                      dropdownData?.countryList?.map((cnt: any) => {
                                        return (
                                          <option key={`issuecountry${cnt?.CountryId}`} value={cnt?.CountryCode} > {cnt?.CountryName} {cnt?.CountryCode ? `(${cnt?.CountryCode})` : ''} </option>
                                        )
                                      })
                                    }
                                  </select>
                                  <label htmlFor={`flightPassportIssueCountryCodeChild${index + 1}`}>Passport Issuance Country</label>
                                  {formError[`flightPassportIssueCountryCodeChild${index + 1}`] && <div className="text-danger f-14">{formError[`flightPassportIssueCountryCodeChild${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating">
                                  <textarea
                                    className="form-control"
                                    placeholder="AddressLine1"
                                    id={`flightAddress1Child${index + 1}`}
                                    name='AddressLine1'
                                    value={obj?.AddressLine1}
                                    onChange={(e) => handleOnChange('child', 'AddressLine1', e.target.value, obj?.id)}
                                    maxLength={250}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightAddress1Child${index + 1}`}>Address Line 1</label>
                                  {formError[`flightAddress1Child${index + 1}`] && <div className="text-danger f-14">{formError[`flightAddress1Child${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating">
                                  <textarea
                                    className="form-control"
                                    placeholder="AddressLine2"
                                    id={`flightAddress2Child${index + 1}`}
                                    name='AddressLine2'
                                    value={obj?.AddressLine2}
                                    onChange={(e) => handleOnChange('child', 'AddressLine2', e.target.value, obj?.id)}
                                    maxLength={250}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightAddress2Child${index + 1}`}>Address Line 2</label>
                                  {formError[`flightAddress2Child${index + 1}`] && <div className="text-danger f-14">{formError[`flightAddress2Child${index + 1}`]}</div>}
                                </div>
                              </div>

                            </div>
                            {/* <!--Frequent flyer preference Form--> */}
                            <button type="button" className='btn p-0'>
                              <h4 className={`frequentFlyer collapsed`} id={`flyerMealChild${index + 1}`} data-bs-toggle="collapse" data-bs-target={`#flyerChild${index + 1}`} >
                                <i className="fa-solid fa-circle-plus"></i> Frequent flyer number and Meal preference (optional)
                              </h4>
                            </button>
                            <div id={`flyerChild${index + 1}`} className={`accordion-collapse collapse `}>
                              <div className="frequentDiv">
                                <div className="row">

                                  <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                    <div className="form-floating mb-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id={`flightFlyerNoChild${index + 1}`}
                                        placeholder="Flyer No"
                                        value={obj?.FFNumber}
                                        onChange={(e) => handleOnChange('child', 'FFNumber', alphaNumeric(e.target.value), obj?.id)}
                                        maxLength={50}
                                        disabled={isDomRtn === 1}
                                      />
                                      <label htmlFor={`flightFlyerNoChild${index + 1}`}>Frequent flyer no.</label>
                                      {formError[`flightFlyerNoChild${index + 1}`] && <div className="text-danger f-14">{formError[`flightFlyerNoChild${index + 1}`]}</div>}
                                    </div>
                                  </div>

                                  <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                    <div className="form-floating mb-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id={`flightAirlineNameChild${index + 1}`}
                                        placeholder="Airline Name"
                                        value={obj?.FFAirlineCode}
                                        onChange={(e) => handleOnChange('child', 'FFAirlineCode', alphaNumeric(e.target.value), obj?.id)}
                                        maxLength={50}
                                        disabled={isDomRtn === 1}
                                      />
                                      <label htmlFor={`flightAirlineNameChild${index + 1}`}>Airline Name</label>
                                      {formError[`flightAirlineNameChild${index + 1}`] && <div className="text-danger f-14">{formError[`flightAirlineNameChild${index + 1}`]}</div>}
                                    </div>
                                  </div>

                                  <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                    <div className="form-floating mb-3">
                                      <select
                                        className="form-select"
                                        id={`flightMealPreferenceChild${index + 1}`}
                                        value={obj?.MealId}
                                        onChange={(e) => handleSelect('child', 'MealId', e, obj?.id)}
                                        disabled={isDomRtn === 1}
                                      >
                                        <option value={0}> Select Meal Preference </option>
                                        {
                                          mealList?.map((obj) => {
                                            return (
                                              <option key={`mealChild${obj?.value}`} value={obj?.value}> {obj?.label} </option>
                                            )
                                          })
                                        }
                                      </select>
                                      <label htmlFor={`flightMealPreferenceChild${index + 1}`}>Meal Preference</label>
                                      {formError[`flightMealPreferenceChild${index + 1}`] && <div className="text-danger f-14">{formError[`flightMealPreferenceChild${index + 1}`]}</div>}
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* <!--Frequent flyer preference Form--> */}
                          </div>
                        </div>
                      )
                    })
                  }
                  {/* <!--Child Traveller Form --> */}

                  {/* <!--Infant Traveller Form--> */}
                  {
                    insertCollection?.infantColl?.length > 0 &&
                    <h3 className="travellerTitle">INFANT (0-2 Yrs)</h3>
                  }
                  {
                    insertCollection?.infantColl?.map((obj: any, index: any) => {
                      return (
                        <div key={`infant${obj?.id}`} className="travellerDiv">
                          <h4 className="heading active">Infant {index + 1}</h4>
                          <div className="form">

                            <div className="row">

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <select
                                    className="form-select"
                                    id={`flightTravelerNameInfant${index + 1}`}
                                    value={obj?.TravelerName}
                                    onChange={(e) => handleSelectSuggestion('infant', e, obj?.id)}
                                    disabled={isDomRtn === 1}
                                  >
                                    <option value={0}> Select Traveler Name </option>
                                    {
                                      dropdownData?.travellerList?.map((list: any) => {
                                        return (
                                          <option key={`infanttravelerName${list?.UserMasterID}`} value={list?.UserMasterID}> {list?.FirstName} </option>
                                        )
                                      })
                                    }
                                  </select>
                                  <label htmlFor={`flightTravelerNameInfant${index + 1}`}>Traveler Name</label>
                                  {formError[`flightTravelerNameInfant${index + 1}`] && <div className="text-danger f-14">{formError[`flightTravelerNameInfant${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <select
                                    className="form-select"
                                    id={`flightTitleSelectInfant${index + 1}`}
                                    value={obj?.TitleId}
                                    onChange={(e) => handleSelect('infant', 'TitleId', e, obj?.id)}
                                    disabled={isDomRtn === 1}
                                  >
                                    <option value={0}> Select Title </option>
                                    {
                                      titleList?.map((obj) => {
                                        return (
                                          <option key={`title${obj?.value}`} value={obj?.value}> {obj?.label} </option>
                                        )
                                      })
                                    }
                                  </select>
                                  <label htmlFor={`flightTitleSelectInfant${index + 1}`}>Title</label>
                                  {formError[`flightTitleSelectInfant${index + 1}`] && <div className="text-danger f-14">{formError[`flightTitleSelectInfant${index + 1}`]}</div>}
                                </div>
                              </div>

                              {/* <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`flightFullNameInfant${index + 1}`}
                                    placeholder="Full Name"
                                    value={obj?.FullName}
                                    onChange={(e) => handleOnChange('infant', 'FullName', onlyAlphabets(e.target.value), obj?.id)}
                                    maxLength={150}
                                  />
                                  <label htmlFor={`flightFullNameInfant${index + 1}`}>Full Name</label>
                                  {formError[`flightFullNameInfant${index + 1}`] && <div className="text-danger f-14">{formError[`flightFullNameInfant${index + 1}`]}</div>}
                                </div>
                              </div> */}

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`flightFirstNameInfant${index + 1}`}
                                    placeholder="First Name"
                                    value={obj?.FirstName}
                                    onChange={(e) =>
                                      e.target.value?.length <= 25 &&
                                      handleOnChange('infant', 'FirstName', AlphabetAllows(e.target.value), obj?.id)
                                    }
                                    maxLength={25}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightFirstNameInfant${index + 1}`}>First Name</label>
                                  {formError[`flightFirstNameInfant${index + 1}`] && <div className="text-danger f-14">{formError[`flightFirstNameInfant${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`flightLastNameInfant${index + 1}`}
                                    placeholder="Last Name"
                                    value={obj?.LastName}
                                    onChange={(e) =>
                                      e.target.value?.length <= 25 &&
                                      handleOnChange('infant', 'LastName', AlphabetAllows(e.target.value), obj?.id)
                                    }
                                    maxLength={25}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightLastNameInfant${index + 1}`}>Last Name</label>
                                  {formError[`flightLastNameInfant${index + 1}`] && <div className="text-danger f-14">{formError[`flightLastNameInfant${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6 mb-3">
                                {/* {
                                  genderList?.map((gender) => {
                                    return (
                                      <div key={`${gender?.label}${gender?.value}`} className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name={`flightInfant${index + 1}`}
                                          id={`flight${gender?.label}Infant${index + 1}`}
                                          value={gender?.value}
                                          checked={obj?.Gender === gender?.value}
                                          onChange={(e) => handleSelect('infant', 'Gender', e, obj?.id)}
                                          disabled
                                        />
                                        <label style={{ opacity: '1' }} className="form-check-label" htmlFor={`flight${gender?.label}Infant${index + 1}`}>
                                          {gender?.label}
                                        </label>
                                      </div>
                                    )
                                  })
                                }
                                {formError[`flightGenderInfant${index + 1}`] && <div className="text-danger f-14">{formError[`flightGenderInfant${index + 1}`]}</div>} */}
                                <div className="form-floating">
                                  <select
                                    className="form-select"
                                    id={`flightgenderSelectInfant${index + 1}`}
                                    value={obj?.Gender}
                                    onChange={(e) => handleSelect('infant', 'Gender', e, obj?.id)}
                                    disabled
                                  >
                                    <option value={0}> Gender </option>
                                    {
                                      genderList?.map((obj) => {
                                        return (
                                          <option key={`gender${obj?.value}`} value={obj?.value}> {obj?.label} </option>
                                        )
                                      })
                                    }
                                  </select>
                                  <label htmlFor={`flightgenderSelectInfant${index + 1}`}>Gender</label>
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="date"
                                    className="form-control"
                                    id={`flightdateOfBirthInfant${index + 1}`}
                                    placeholder="Date of Birth"
                                    max={formatDate(new Date()) || ''}
                                    min={formatDate(new Date(minDOB)) || ''}
                                    value={obj.tempDOB}
                                    onChange={(e) => handleDateChange('infant', 'tempDOB', e, obj?.id)}
                                    onClick={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    onKeyDown={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightdateOfBirthInfant${index + 1}`}>Date of Birth</label>
                                  {formError[`flightdateOfBirthInfant${index + 1}`] && <div className="text-danger f-14">{formError[`flightdateOfBirthInfant${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`flightAgeInfant${index + 1}`}
                                    placeholder="Age"
                                    value={obj?.Age}
                                    onChange={(e) => handleOnChange('adult', 'Age', e.target.value, obj?.id)}
                                    disabled
                                  />
                                  <label htmlFor={`flightAgeInfant${index + 1}`}>Age</label>
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`flightPassportNumberInfant${index + 1}`}
                                    placeholder="Passport Number"
                                    value={obj?.PassportNo}
                                    onChange={(e) => handleOnChange('infant', 'PassportNo', alphaNumeric(e.target.value), obj?.id)}
                                    maxLength={10}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightPassportNumberInfant${index + 1}`}>Passport number</label>
                                  {formError[`flightPassportNumberInfant${index + 1}`] && <div className="text-danger f-14">{formError[`flightPassportNumberInfant${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="date"
                                    className="form-control"
                                    id={`flightPassportIssueDateInfant${index + 1}`}
                                    placeholder="Passport Issuance Date"
                                    value={obj.tempPassportIssueDate}
                                    onChange={(e) => handleDateChange('infant', 'tempPassportIssueDate', e, obj?.id)}
                                    onClick={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    onKeyDown={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightPassportIssueDateInfant${index + 1}`}>Passport Issuance Date</label>
                                  {formError[`flightPassportIssueDateInfant${index + 1}`] && <div className="text-danger f-14">{formError[`flightPassportIssueDateInfant${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <input
                                    type="date"
                                    className="form-control"
                                    id={`flightPassportExpiryInfant${index + 1}`}
                                    placeholder="Passport expiry date"
                                    value={obj.tempExpiryDate}
                                    onChange={(e) => handleDateChange('infant', 'tempExpiryDate', e, obj?.id)}
                                    onClick={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    onKeyDown={(e: any) => {
                                      e.preventDefault();
                                      (e.currentTarget as HTMLInputElement)?.showPicker();
                                    }}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightPassportExpiryInfant${index + 1}`}>Passport expiry date</label>
                                  {formError[`flightPassportExpiryInfant${index + 1}`] && <div className="text-danger f-14">{formError[`flightPassportExpiryInfant${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating mb-3">
                                  <select
                                    className="form-select"
                                    id={`flightPassportIssueCountryCodeInfant${index + 1}`}
                                    value={obj?.PassportIssueCountryCode}
                                    onChange={(e) => handleSelect('infant', 'PassportIssueCountryCode', e, obj?.id)}
                                    disabled={isDomRtn === 1}
                                  >
                                    <option value={""}> Select Issuance Country </option>
                                    {
                                      dropdownData?.countryList?.map((cnt: any) => {
                                        return (
                                          <option key={`issuecountry${cnt?.CountryId}`} value={cnt?.CountryCode} > {cnt?.CountryName} {cnt?.CountryCode ? `(${cnt?.CountryCode})` : ''} </option>
                                        )
                                      })
                                    }
                                  </select>
                                  <label htmlFor={`flightPassportIssueCountryCodeInfant${index + 1}`}>Passport Issuance Country</label>
                                  {formError[`flightPassportIssueCountryCodeInfant${index + 1}`] && <div className="text-danger f-14">{formError[`flightPassportIssueCountryCodeInfant${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating">
                                  <textarea
                                    className="form-control"
                                    placeholder="AddressLine1"
                                    id={`flightAddress1Infant${index + 1}`}
                                    name='AddressLine1'
                                    value={obj?.AddressLine1}
                                    onChange={(e) => handleOnChange('infant', 'AddressLine1', e.target.value, obj?.id)}
                                    maxLength={250}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightAddress1Infant${index + 1}`}>Address Line 1</label>
                                  {formError[`flightAddress1Infant${index + 1}`] && <div className="text-danger f-14">{formError[`flightAddress1Infant${index + 1}`]}</div>}
                                </div>
                              </div>

                              <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                <div className="form-floating">
                                  <textarea
                                    className="form-control"
                                    placeholder="AddressLine2"
                                    id={`flightAddress2Infant${index + 1}`}
                                    name='AddressLine2'
                                    value={obj?.AddressLine2}
                                    onChange={(e) => handleOnChange('infant', 'AddressLine2', e.target.value, obj?.id)}
                                    maxLength={250}
                                    disabled={isDomRtn === 1}
                                  />
                                  <label htmlFor={`flightAddress2Infant${index + 1}`}>Address Line 2</label>
                                  {formError[`flightAddress2Infant${index + 1}`] && <div className="text-danger f-14">{formError[`flightAddress2Infant${index + 1}`]}</div>}
                                </div>
                              </div>
                            </div>
                            {/* <!--Frequent flyer preference Form--> */}
                            <button type="button" className='btn p-0'>
                              <h4 className={`frequentFlyer collapsed`} id={`flyerMealInfant${index + 1}`} data-bs-toggle="collapse" data-bs-target={`#flyerInfant${index + 1}`} >
                                <i className="fa-solid fa-circle-plus"></i> Frequent flyer number and Meal preference (optional)
                              </h4>
                            </button>
                            <div id={`flyerInfant${index + 1}`} className={`accordion-collapse collapse `}>
                              <div className="frequentDiv">
                                <div className="row">

                                  <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                    <div className="form-floating mb-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id={`flightFlyerNoInfant${index + 1}`}
                                        placeholder="Flyer No"
                                        value={obj?.FFNumber}
                                        onChange={(e) => handleOnChange('infant', 'FFNumber', alphaNumeric(e.target.value), obj?.id)}
                                        maxLength={50}
                                        disabled={isDomRtn === 1}
                                      />
                                      <label htmlFor={`flightFlyerNoInfant${index + 1}`}>Frequent flyer no.</label>
                                      {formError[`flightFlyerNoInfant${index + 1}`] && <div className="text-danger f-14">{formError[`flightFlyerNoInfant${index + 1}`]}</div>}
                                    </div>
                                  </div>

                                  <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                    <div className="form-floating mb-3">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id={`flightAirlineNameInfant${index + 1}`}
                                        placeholder="Airline Name"
                                        value={obj?.FFAirlineCode}
                                        onChange={(e) => handleOnChange('infant', 'FFAirlineCode', alphaNumeric(e.target.value), obj?.id)}
                                        maxLength={50}
                                        disabled={isDomRtn === 1}
                                      />
                                      <label htmlFor={`flightAirlineNameInfant${index + 1}`}>Airline Name</label>
                                      {formError[`flightAirlineNameInfant${index + 1}`] && <div className="text-danger f-14">{formError[`flightAirlineNameInfant${index + 1}`]}</div>}
                                    </div>
                                  </div>

                                  <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                                    <div className="form-floating mb-3">
                                      <select
                                        className="form-select"
                                        id={`flightMealPreferenceInfant${index + 1}`}
                                        value={obj?.MealId}
                                        onChange={(e) => handleSelect('infant', 'MealId', e, obj?.id)}
                                        disabled={isDomRtn === 1}
                                      >
                                        <option value={0}> Select Meal Preference </option>
                                        {
                                          mealList?.map((obj) => {
                                            return (
                                              <option key={`mealInfant${obj?.value}`} value={obj?.value}> {obj?.label} </option>
                                            )
                                          })
                                        }
                                      </select>
                                      <label htmlFor={`flightMealPreferenceInfant${index + 1}`}>Meal Preference</label>
                                      {formError[`flightMealPreferenceInfant${index + 1}`] && <div className="text-danger f-14">{formError[`flightMealPreferenceInfant${index + 1}`]}</div>}
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* <!--Frequent flyer preference Form--> */}
                          </div>
                        </div>
                      )
                    })
                  }
                  {/* <!--Infant Traveller Form--> */}

                  {/* <!--Booking details will be send your Contact Details --> */}
                  <div className="travellerDiv">
                    <div className="title">
                      <h4>Contact Details</h4>
                    </div>
                    <div className="form">
                      <div className="row">

                        <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                          <div className="form-floating mb-3">
                            <input
                              type="text"
                              className="form-control"
                              id="ContactCountry"
                              placeholder="Country Code"
                              name='ContactCountry'
                              value={formValue?.CountryName ? `${formValue?.CountryName} (${formValue?.CellCountryCode})` : ''}
                              onChange={(e) => onChangeContactDetail(e.target.name, e.target.value)}
                              disabled
                            />
                            {/* <select
                              className="form-select"
                              id={`CountryId`}
                              name='CountryId'
                              value={formValue?.CountryId}
                              onChange={(e) => handleSelectChange(e.target.value)}
                              disabled
                            >
                              <option value={0}> Select Country </option>
                              {
                                dropdownData?.countryList?.map((cnt) => {
                                  return (
                                    <option key={`contactcountry${cnt?.CountryId}`} value={cnt?.CountryId} > {cnt?.CountryName} {cnt?.ISDCode ? `(${cnt?.ISDCode})` : ''} </option>
                                  )
                                })
                              }
                            </select> */}
                            <label htmlFor={`CountryId`}>Country Code</label>
                            {formError[`CountryId`] && <div className="text-danger f-14">{formError[`CountryId`]}</div>}
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                          <div className="form-floating mb-3">
                            <input
                              type="text"
                              className="form-control"
                              id="ContactCity"
                              placeholder="Mobile No"
                              name='ContactCity'
                              value={formValue?.City}
                              onChange={(e) => onChangeContactDetail(e.target.name, e.target.value)}
                              disabled
                            />
                            {/* <select
                              className="form-select"
                              id={`AirportLocationId`}
                              name='AirportLocationId'
                              value={formValue?.AirportLocationId}
                              onChange={(e) => handleSelectChange(e.target.value)}
                              disabled
                            >
                              <option value={0}> Select City </option>
                              {
                                dropdownData?.cityList?.filter((fil) => fil?.CountryId === Number(formValue?.CountryId))?.map((city, index) => {
                                  return (
                                    <option key={`contactcity${index}${city?.CityCode}`} value={city?.City} > {city?.City} </option>
                                  )
                                })
                              }
                            </select> */}
                            <label htmlFor={`AirportLocationId`}>City</label>
                            {formError[`AirportLocationId`] && <div className="text-danger f-14">{formError[`AirportLocationId`]}</div>}
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                          <div className="form-floating mb-3">
                            <input
                              type="text"
                              className="form-control"
                              id="MobileNo"
                              placeholder="Mobile No"
                              name='MobileNo'
                              value={formValue?.MobileNo}
                              onChange={(e) => onChangeContactDetail(e.target.name, onlyNumeric(e.target.value))}
                              disabled
                            />
                            <label htmlFor="MobileNo">Mobile No</label>
                            {formError[`MobileNo`] && <div className="text-danger f-14">{formError[`MobileNo`]}</div>}
                          </div>
                        </div>

                        <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                          <div className="form-floating mb-3">
                            <input
                              type="email"
                              className="form-control"
                              id="Email"
                              placeholder="email"
                              name='Email'
                              value={formValue?.Email}
                              onChange={(e) => onChangeContactDetail(e.target.name, e.target.value)}
                              disabled
                            />
                            {formError?.Email && <div className="text-danger f-14">{formError?.Email}</div>}
                            <label htmlFor="Email">Email</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!--Booking details will be send your Contact Details --> */}

                  {/* <!--Use GST for this booking --> */}
                  <div className="travellerDiv">
                    <div className="heading">
                      <span className="form-check">
                        <input
                          className={`form-check-input ${formValue?.IsGST ? '' : 'collapsed'}  `}
                          type="checkbox"
                          checked={formValue?.IsGST}
                          name='IsGST' id="IsGST"
                          onChange={(e) => handleChecked('IsGST', e)}
                          disabled={isDomRtn === 1}
                          data-bs-toggle="collapse" data-bs-target="#usegst" />
                        <label className="form-check-label" htmlFor="IsGST">
                          Use GST for this booking
                        </label>
                      </span>
                    </div>

                    <div id="usegst" className={`accordion-collapse collapse ${formValue?.IsGST ? 'show' : ''} `}>
                      <div className="form">
                        <div className="row">
                          <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                            <div className="form-floating mb-3">
                              <input
                                type="text"
                                className="form-control"
                                id="GSTNumber"
                                placeholder="GST No"
                                name='GSTNumber'
                                value={formValue?.GSTNumber}
                                onChange={(e) => onChange(e.target.name, e.target.value)}
                                maxLength={15}
                                disabled={isDomRtn === 1}
                              />
                              <label htmlFor="GSTNumber">GST Number</label>
                              {formError?.GSTNumber && <div className="text-danger f-14">{formError?.GSTNumber}</div>}
                            </div>
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                            <div className="form-floating mb-3">
                              <input
                                type="text"
                                className="form-control"
                                id="GSTCompanyName"
                                placeholder="GST Company Name"
                                name='GSTCompanyName'
                                value={formValue?.GSTCompanyName}
                                onChange={(e) => onChange(e.target.name, alphaNumericWithSpace(e.target.value))}
                                maxLength={50}
                                disabled={isDomRtn === 1}
                              />
                              <label htmlFor="GSTCompanyName">GST Company Name</label>
                              {formError?.GSTCompanyName && <div className="text-danger f-14">{formError?.GSTCompanyName}</div>}
                            </div>
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                            <div className="form-floating mb-3">
                              <input
                                type="text"
                                className="form-control"
                                id="GSTCompanyContactNumber"
                                placeholder="GST Company Contact"
                                name='GSTCompanyContactNumber'
                                value={formValue?.GSTCompanyContactNumber}
                                onChange={(e) => onChange(e.target.name, onlyNumeric(e.target.value))}
                                maxLength={12}
                                disabled={isDomRtn === 1}
                              />
                              <label htmlFor="GSTCompanyContactNumber">GST Company Contact</label>
                              {formError?.GSTCompanyContactNumber && <div className="text-danger f-14">{formError?.GSTCompanyContactNumber}</div>}
                            </div>
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                            <div className="form-floating mb-3">
                              <input
                                type="email"
                                className="form-control"
                                id="GSTCompanyEmail"
                                placeholder="GST Company Email"
                                name='GSTCompanyEmail'
                                value={formValue?.GSTCompanyEmail}
                                onChange={(e) => onChange(e.target.name, e.target.value)}
                                maxLength={150}
                                disabled={isDomRtn === 1}
                              />
                              <label htmlFor="GSTCompanyEmail">GST Company Email</label>
                              {formError?.GSTCompanyEmail && <div className="text-danger f-14">{formError?.GSTCompanyEmail}</div>}
                            </div>
                          </div>
                          <div className="col-xl-4 col-lg-6 col-md-4 col-sm-6">
                            <div className="form-floating mb-3">
                              <input
                                type="text"
                                className="form-control"
                                id="GSTCompanyAddress"
                                placeholder="GST Company Address"
                                name='GSTCompanyAddress'
                                value={formValue?.GSTCompanyAddress}
                                onChange={(e) => onChange(e.target.name, e.target.value)}
                                maxLength={150}
                                disabled={isDomRtn === 1}
                              />
                              <label htmlFor="GSTCompanyAddress">GST Company Address</label>
                              {formError?.GSTCompanyAddress && <div className="text-danger f-14">{formError?.GSTCompanyAddress}</div>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!--Use GST for this booking --> */}
                </div>
              </div>
            </div>
            {/* <!--Free medical Refund policy--> */}

            <button type='button' className="btn continueBtn" onClick={() => handleContinue()} >Continue</button>


          </form>

        </div>

        <div className="rightSec">
          <div className="holidayPriceSummary">
            <PriceSummary
              adultPrice={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn, true, 1)?.baseFare}
              adultCount={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn, true, 1)?.passengerCount}
              childPrice={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn, true, 2)?.baseFare}
              childCount={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn, true, 2)?.passengerCount}
              infantPrice={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn, true, 3)?.baseFare}
              infantCount={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn, true, 3)?.passengerCount}
              taxValue={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn)?.totalTaxAndSurcharges}
              otherValue={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn)?.otherCharges}
              finalValue={getPriceSummaryDetails(UpdatedBookFlightData(isDomRtn), flightFareQouteData, isDomRtn)?.grandTotal}
            />
            <button type='button' className="btn continueBtn" onClick={() => handleContinue()} >Continue</button>
          </div>

        </div>
      </div>
    </>
  )
}

export default FlightAddTravellerForm
